// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =================================================================
   KIU RESOURCE MANAGER - MODERN GLASSMORPHIC DESIGN SYSTEM
   All colors are defined here as CSS Variables so you can customize
   or replace the color palette anytime in one place!
   ================================================================= */

:root {
  /* -------------------------------------------------------------
     1. PRIMARY & BRAND PALETTE (Easily swappable)
     ------------------------------------------------------------- */
  --rm-primary: #4F46E5;                /* Vibrant Indigo */
  --rm-primary-hover: #4338CA;
  --rm-primary-light: rgba(79, 70, 229, 0.10);
  --rm-primary-border: rgba(79, 70, 229, 0.25);
  --rm-primary-gradient: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
  --rm-primary-glow: rgba(79, 70, 229, 0.25);

  --rm-secondary: #06B6D4;              /* Cyan Ocean */
  --rm-secondary-hover: #0891B2;
  --rm-secondary-light: rgba(6, 182, 212, 0.10);
  --rm-secondary-gradient: linear-gradient(135deg, #06B6D4 0%, #3B82F6 100%);

  --rm-accent-purple: #8B5CF6;
  --rm-accent-gradient: linear-gradient(135deg, #8B5CF6 0%, #EC4899 100%);

  /* -------------------------------------------------------------
     2. STATUS / SEMANTIC COLORS
     ------------------------------------------------------------- */
  --rm-success: #10B981;                /* Emerald */
  --rm-success-light: rgba(16, 185, 129, 0.12);
  --rm-success-border: rgba(16, 185, 129, 0.25);
  --rm-success-gradient: linear-gradient(135deg, #10B981 0%, #059669 100%);

  --rm-warning: #F59E0B;                /* Amber */
  --rm-warning-light: rgba(245, 158, 11, 0.12);
  --rm-warning-border: rgba(245, 158, 11, 0.25);
  --rm-warning-gradient: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);

  --rm-danger: #EF4444;                 /* Rose Red */
  --rm-danger-light: rgba(239, 68, 68, 0.12);
  --rm-danger-border: rgba(239, 68, 68, 0.25);
  --rm-danger-gradient: linear-gradient(135deg, #EF4444 0%, #DC2626 100%);

  --rm-info: #0284C7;                   /* Sky Blue */
  --rm-info-light: rgba(2, 132, 199, 0.12);
  --rm-info-border: rgba(2, 132, 199, 0.25);
  --rm-info-gradient: linear-gradient(135deg, #0284C7 0%, #0369A1 100%);

  /* -------------------------------------------------------------
     3. GLASSMORPHISM & SURFACE DESIGN TOKENS
     ------------------------------------------------------------- */
  --rm-bg-main: #F4F7FC;                /* Premium soft slate background */
  --rm-bg-mesh: radial-gradient(at 0% 0%, rgba(79, 70, 229, 0.08) 0px, transparent 50%),
                 radial-gradient(at 100% 0%, rgba(6, 182, 212, 0.08) 0px, transparent 50%),
                 radial-gradient(at 50% 100%, rgba(139, 92, 246, 0.06) 0px, transparent 50%),
                 #F4F7FC;
  --rm-surface: #FFFFFF;

  --rm-glass-bg: rgba(255, 255, 255, 0.82);
  --rm-glass-bg-hover: rgba(255, 255, 255, 0.95);
  --rm-glass-border: rgba(255, 255, 255, 0.7);
  --rm-glass-border-subtle: rgba(226, 232, 240, 0.85);
  --rm-glass-blur: blur(16px);
  --rm-glass-shadow: 0 10px 30px -5px rgba(15, 23, 42, 0.06), 0 4px 8px -2px rgba(15, 23, 42, 0.03);
  --rm-glass-shadow-hover: 0 20px 35px -5px rgba(79, 70, 229, 0.12), 0 8px 12px -3px rgba(15, 23, 42, 0.05);

  /* -------------------------------------------------------------
     4. TYPOGRAPHY & TEXT
     ------------------------------------------------------------- */
  --rm-text-primary: #0F172A;
  --rm-text-secondary: #475569;
  --rm-text-muted: #94A3B8;

  /* -------------------------------------------------------------
     5. GEOMETRY & TRANSITIONS
     ------------------------------------------------------------- */
  --rm-radius-sm: 8px;
  --rm-radius-md: 14px;
  --rm-radius-lg: 20px;
  --rm-radius-xl: 28px;
  --rm-radius-full: 9999px;
  --rm-transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

/* =================================================================
   BASE & PAGE WRAPPER MODERNIZATION
   ================================================================= */
.page-wrapper {
  background: var(--rm-bg-mesh) !important;
  min-height: 100vh;
  transition: var(--rm-transition);
}

/* =================================================================
   GLASSMORPHIC CARDS & CONTAINERS
   ================================================================= */
.rm-glass-card {
  background: var(--rm-glass-bg) !important;
  backdrop-filter: var(--rm-glass-blur) !important;
  -webkit-backdrop-filter: var(--rm-glass-blur) !important;
  border: 1px solid var(--rm-glass-border) !important;
  border-radius: var(--rm-radius-lg) !important;
  box-shadow: var(--rm-glass-shadow) !important;
  transition: var(--rm-transition);
  position: relative;
  overflow: visible;
}

.rm-glass-card.rm-clipped {
  overflow: hidden !important;
}

.rm-overflow-visible,
.card.rm-overflow-visible,
.rm-glass-card.rm-overflow-visible {
  overflow: visible !important;
}

.rm-glass-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);
  pointer-events: none;
}

.rm-glass-card-interactive:hover {
  transform: translateY(-4px);
  box-shadow: var(--rm-glass-shadow-hover) !important;
  border-color: rgba(79, 70, 229, 0.3) !important;
}

/* =================================================================
   HERO WELCOME BANNER
   ================================================================= */
.rm-hero-banner {
  background: linear-gradient(135deg, #1E1B4B 0%, #312E81 50%, #4338CA 100%) !important;
  border-radius: var(--rm-radius-xl) !important;
  padding: 28px 32px !important;
  color: #FFFFFF !important;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 40px -15px rgba(49, 46, 129, 0.45), 0 0 20px rgba(79, 70, 229, 0.2) !important;
  margin-bottom: 24px !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
}

.rm-hero-banner::after {
  content: "";
  position: absolute;
  top: -60px;
  right: -60px;
  width: 240px;
  height: 240px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.18) 0%, transparent 70%);
  pointer-events: none;
}

.rm-hero-title,
.rm-hero-banner h1,
.rm-hero-banner h2,
.rm-hero-banner h3,
.rm-hero-banner h4,
.rm-hero-banner h5 {
  color: #FFFFFF !important;
  font-size: 1.75rem !important;
  font-weight: 700 !important;
  letter-spacing: -0.02em;
  margin-bottom: 6px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
}

.rm-hero-subtitle {
  color: rgba(255, 255, 255, 0.88) !important;
  font-size: 0.95rem;
}

.rm-hero-badge {
  background: rgba(255, 255, 255, 0.18) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  color: #FFFFFF !important;
  backdrop-filter: blur(8px);
  font-weight: 600;
  letter-spacing: 0.03em;
}

.rm-hero-date {
  color: rgba(255, 255, 255, 0.78) !important;
}

.rm-hero-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* =================================================================
   QUICK ACTION BUTTONS
   ================================================================= */
.rm-action-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: var(--rm-radius-full);
  font-weight: 600;
  font-size: 0.875rem;
  text-decoration: none !important;
  transition: var(--rm-transition);
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: rgba(255, 255, 255, 0.12);
  color: #FFFFFF !important;
  backdrop-filter: blur(8px);
}

.rm-action-pill:hover {
  background: #FFFFFF;
  color: var(--rm-primary) !important;
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}

/* =================================================================
   TOP KPI STAT SUMMARY CARDS
   ================================================================= */
.rm-kpi-card {
  padding: 22px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: var(--rm-radius-lg);
  background: var(--rm-glass-bg);
  backdrop-filter: var(--rm-glass-blur);
  border: 1px solid var(--rm-glass-border);
  box-shadow: var(--rm-glass-shadow);
  transition: var(--rm-transition);
  position: relative;
  overflow: hidden;
}

.rm-kpi-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--rm-glass-shadow-hover);
}

.rm-kpi-icon-wrap {
  width: 54px;
  height: 54px;
  border-radius: var(--rm-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
  transition: var(--rm-transition);
}

.rm-kpi-card:hover .rm-kpi-icon-wrap {
  transform: scale(1.08) rotate(3deg);
}

.rm-kpi-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--rm-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 4px;
}

.rm-kpi-val {
  font-size: 1.85rem;
  font-weight: 800;
  color: var(--rm-text-primary);
  line-height: 1.1;
  margin-bottom: 4px;
}

.rm-kpi-sub {
  font-size: 0.775rem;
  color: var(--rm-text-muted);
}

/* Sub-card inside widget */
.rm-sub-glass-item {
  padding: 14px 16px;
  border-radius: var(--rm-radius-md);
  background: rgba(255, 255, 255, 0.65);
  border: 1px solid rgba(226, 232, 240, 0.7);
  transition: var(--rm-transition);
}

.rm-sub-glass-item:hover {
  background: rgba(255, 255, 255, 0.95);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);
}

.rm-sub-glass-num {
  font-size: 1.45rem;
  font-weight: 800;
  line-height: 1.2;
}

/* =================================================================
   MOBILE RESPONSIVENESS (100% Mobile Ready)
   ================================================================= */
@media (max-width: 991.98px) {
  .rm-hero-banner {
    padding: 20px;
    border-radius: var(--rm-radius-lg);
  }
  
  .rm-hero-title {
    font-size: 1.35rem;
  }
  
  .rm-hero-actions {
    margin-top: 14px;
    width: 100%;
  }

  .rm-action-pill {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    justify-content: center;
    padding: 8px 12px;
    font-size: 0.8rem;
  }
  
  .rm-kpi-card {
    padding: 16px 18px;
  }

  .rm-kpi-val {
    font-size: 1.5rem;
  }
}

@media (max-width: 575.98px) {
  .rm-hero-banner {
    padding: 16px;
  }

  .rm-action-pill {
    flex: 1 1 100%;
  }

  .page-wrapper .content {
    padding: 12px 8px !important;
  }

  .rm-glass-card {
    border-radius: var(--rm-radius-md) !important;
  }

  .rm-sub-glass-num {
    font-size: 1.2rem;
  }
}

/* =================================================================
   HEADER & SIDEBAR STYLES
   ================================================================= */
.sidebar .sidebar-menu > ul > li > a {
  border-radius: var(--rm-radius-md) !important;
  margin: 4px 10px !important;
  transition: var(--rm-transition) !important;
  color: var(--rm-text-secondary) !important;
  font-weight: 500;
}

.sidebar .sidebar-menu > ul > li > a:hover {
  background: var(--rm-primary-light) !important;
  color: var(--rm-primary) !important;
}

.sidebar .sidebar-menu > ul > li.active > a {
  background: var(--rm-primary-gradient) !important;
  color: #FFFFFF !important;
  box-shadow: 0 6px 16px -2px var(--rm-primary-glow) !important;
}

/* =================================================================
   UNIVERSAL BUTTON MODERNIZATION (Across All Pages)
   ================================================================= */
.btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  letter-spacing: 0.01em;
  padding: 8px 18px !important;
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1) !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px !important;
  position: relative;
  overflow: hidden;
  border: 1px solid transparent !important;
}

.btn:active {
  transform: scale(0.97) !important;
}

/* Primary Button */
.btn-primary,
.btn-save,
.btn-send {
  background: var(--rm-primary-gradient) !important;
  border-color: transparent !important;
  color: #FFFFFF !important;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.28) !important;
}

.btn-primary:hover,
.btn-save:hover,
.btn-send:hover {
  background: linear-gradient(135deg, #4338CA 0%, #6D28D9 100%) !important;
  color: #FFFFFF !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(79, 70, 229, 0.4) !important;
}

/* Secondary Button */
.btn-secondary {
  background: var(--rm-secondary-gradient) !important;
  border-color: transparent !important;
  color: #FFFFFF !important;
  box-shadow: 0 4px 12px rgba(6, 182, 212, 0.28) !important;
}

.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(6, 182, 212, 0.4) !important;
}

/* Success Button */
.btn-success {
  background: var(--rm-success-gradient) !important;
  border-color: transparent !important;
  color: #FFFFFF !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.28) !important;
}

.btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(16, 185, 129, 0.4) !important;
}

/* Danger Button */
.btn-danger {
  background: var(--rm-danger-gradient) !important;
  border-color: transparent !important;
  color: #FFFFFF !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.28) !important;
}

.btn-danger:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(239, 68, 68, 0.4) !important;
}

/* Warning Button */
.btn-warning {
  background: var(--rm-warning-gradient) !important;
  border-color: transparent !important;
  color: #FFFFFF !important;
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.28) !important;
}

.btn-warning:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(245, 158, 11, 0.4) !important;
}

/* Info Button */
.btn-info {
  background: var(--rm-info-gradient) !important;
  border-color: transparent !important;
  color: #FFFFFF !important;
  box-shadow: 0 4px 12px rgba(2, 132, 199, 0.28) !important;
}

/* Outline Buttons */
.btn-outline-primary {
  border-color: var(--rm-primary) !important;
  color: var(--rm-primary) !important;
  background: rgba(79, 70, 229, 0.05) !important;
}

.btn-outline-primary:hover {
  background: var(--rm-primary-gradient) !important;
  color: #FFFFFF !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.3) !important;
}

.btn-outline-secondary {
  border-color: #CBD5E1 !important;
  color: var(--rm-text-secondary) !important;
  background: rgba(255, 255, 255, 0.7) !important;
}

.btn-outline-secondary:hover {
  background: #F1F5F9 !important;
  color: var(--rm-text-primary) !important;
  transform: translateY(-2px);
}

.btn-reset,
.btn-cancel {
  background: #F1F5F9 !important;
  color: #475569 !important;
  border: 1px solid #E2E8F0 !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
}

.btn-reset:hover,
.btn-cancel:hover {
  background: #E2E8F0 !important;
  color: #0F172A !important;
}

/* Action Table Icon Buttons */
.action-table-data a,
.table-action-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: var(--rm-transition);
  background: rgba(241, 245, 249, 0.8);
  color: var(--rm-text-secondary) !important;
  margin: 0 3px;
}

.action-table-data a:hover,
.table-action-btn:hover {
  background: var(--rm-primary-light);
  color: var(--rm-primary) !important;
  transform: scale(1.1);
}

/* =================================================================
   UNIVERSAL TABLE MODERNIZATION (Ant Design & Bootstrap Tables)
   ================================================================= */
.card .table,
.table-responsive,
.data-table-card,
.ant-table-wrapper {
  border-radius: var(--rm-radius-lg);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Ant Table & General Table Container */
.ant-table,
.table {
  background: transparent !important;
  color: var(--rm-text-primary) !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  width: 100%;
}

/* Table Header */
.ant-table-thead > tr > th,
.table thead th {
  background: #F8FAFC !important;
  color: #475569 !important;
  font-weight: 700 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  padding: 14px 16px !important;
  border-bottom: 2px solid #E2E8F0 !important;
  border-top: none !important;
  white-space: nowrap;
}

/* Table Rows & Cells */
.ant-table-tbody > tr > td,
.table tbody td {
  padding: 14px 16px !important;
  vertical-align: middle !important;
  border-bottom: 1px solid rgba(226, 232, 240, 0.75) !important;
  color: #334155 !important;
  font-size: 0.875rem !important;
  background: transparent !important;
  transition: background 0.15s ease !important;
}

/* Row Hover Highlight */
.ant-table-tbody > tr:hover > td,
.table-hover tbody tr:hover td {
  background: rgba(79, 70, 229, 0.04) !important;
}

/* Data Table Card Wrapper */
.data-table-card {
  background: var(--rm-glass-bg) !important;
  backdrop-filter: var(--rm-glass-blur) !important;
  -webkit-backdrop-filter: var(--rm-glass-blur) !important;
  border: 1px solid var(--rm-glass-border) !important;
  border-radius: var(--rm-radius-lg) !important;
  box-shadow: var(--rm-glass-shadow) !important;
  padding: 16px !important;
  margin-bottom: 24px !important;
}

/* Modern Ant Pagination */
.ant-pagination {
  margin-top: 20px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 6px !important;
}

.ant-pagination .ant-pagination-item {
  border-radius: 8px !important;
  border: 1px solid #E2E8F0 !important;
  font-weight: 600 !important;
  background: #FFFFFF !important;
  transition: var(--rm-transition) !important;
}

.ant-pagination .ant-pagination-item-active {
  background: var(--rm-primary-gradient) !important;
  border-color: transparent !important;
  box-shadow: 0 4px 10px rgba(79, 70, 229, 0.3) !important;
}

.ant-pagination .ant-pagination-item-active a {
  color: #FFFFFF !important;
}

.ant-pagination .ant-pagination-prev .ant-pagination-item-link,
.ant-pagination .ant-pagination-next .ant-pagination-item-link {
  border-radius: 8px !important;
  border: 1px solid #E2E8F0 !important;
  background: #FFFFFF !important;
}

/* =================================================================
   UNIVERSAL CARDS & CONTAINERS (Across All Pages)
   ================================================================= */
.card {
  background: var(--rm-glass-bg) !important;
  backdrop-filter: var(--rm-glass-blur) !important;
  -webkit-backdrop-filter: var(--rm-glass-blur) !important;
  border: 1px solid var(--rm-glass-border) !important;
  border-radius: var(--rm-radius-lg) !important;
  box-shadow: var(--rm-glass-shadow) !important;
  transition: var(--rm-transition) !important;
  margin-bottom: 20px !important;
}

.card:hover {
  box-shadow: var(--rm-glass-shadow-hover) !important;
}

.card-header {
  background: transparent !important;
  border-bottom: 1px solid rgba(226, 232, 240, 0.7) !important;
  padding: 18px 22px !important;
}

.card-body {
  padding: 20px 22px !important;
}

/* =================================================================
   FORM CONTROLS & INPUTS (Sleek Modern Touch)
   ================================================================= */
.form-control,
.form-select {
  border-radius: 10px !important;
  border: 1.5px solid #E2E8F0 !important;
  padding: 10px 14px !important;
  font-size: 0.9rem !important;
  background-color: #FFFFFF !important;
  color: var(--rm-text-primary) !important;
  transition: var(--rm-transition) !important;
}

.form-control:focus,
.form-select:focus {
  border-color: var(--rm-primary) !important;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.16) !important;
  background-color: #FFFFFF !important;
}

/* =================================================================
   SOFT STATUS BADGES
   ================================================================= */
.badge {
  border-radius: var(--rm-radius-full) !important;
  padding: 6px 12px !important;
  font-weight: 600 !important;
  font-size: 0.775rem !important;
  letter-spacing: 0.02em !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
}

.badge-soft-success,
.badge-success {
  background: var(--rm-success-light) !important;
  color: var(--rm-success) !important;
  border: 1px solid var(--rm-success-border) !important;
}

.badge-soft-danger,
.badge-danger {
  background: var(--rm-danger-light) !important;
  color: var(--rm-danger) !important;
  border: 1px solid var(--rm-danger-border) !important;
}

.badge-soft-warning,
.badge-warning {
  background: var(--rm-warning-light) !important;
  color: #D97706 !important;
  border: 1px solid var(--rm-warning-border) !important;
}

.badge-soft-info,
.badge-info {
  background: var(--rm-info-light) !important;
  color: var(--rm-info) !important;
  border: 1px solid var(--rm-info-border) !important;
}

.badge-soft-primary,
.badge-primary {
  background: var(--rm-primary-light) !important;
  color: var(--rm-primary) !important;
  border: 1px solid var(--rm-primary-border) !important;
}

/* =================================================================
   MODALS (Glassmorphic Dialogs)
   ================================================================= */
.modal-content {
  border-radius: var(--rm-radius-xl) !important;
  background: rgba(255, 255, 255, 0.96) !important;
  backdrop-filter: blur(20px) !important;
  border: 1px solid var(--rm-glass-border) !important;
  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.25) !important;
  overflow: hidden;
}

.modal-header {
  border-bottom: 1px solid rgba(226, 232, 240, 0.8) !important;
  padding: 20px 24px !important;
}

.modal-footer {
  border-top: 1px solid rgba(226, 232, 240, 0.8) !important;
  padding: 16px 24px !important;
}

/* =================================================================
   ROOM REGISTER & ARCHITECTURAL BLUEPRINT SUITE
   ================================================================= */
.roomreg-shell {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.roomreg-header-card {
  background: var(--rm-glass-bg);
  backdrop-filter: var(--rm-glass-blur);
  border: 1px solid var(--rm-glass-border-subtle);
  border-radius: var(--rm-radius-lg);
  padding: 1.25rem 1.5rem;
  box-shadow: var(--rm-glass-shadow);
}

.floor-pill-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: var(--rm-radius-full);
  font-size: 0.875rem;
  font-weight: 600;
  border: 1px solid rgba(203, 213, 225, 0.8);
  background: rgba(255, 255, 255, 0.9);
  color: var(--rm-text-secondary);
  transition: var(--rm-transition);
  cursor: pointer;
  white-space: nowrap;
}

.floor-pill-btn:hover {
  background: #ffffff;
  border-color: var(--rm-primary);
  color: var(--rm-primary);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.12);
}

.floor-pill-btn.active {
  background: var(--rm-primary-gradient);
  border-color: transparent;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(79, 70, 229, 0.35);
}

.roomreg-workspace {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 1.25rem;
  align-items: start;
}

@media (max-width: 1100px) {
  .roomreg-workspace {
    grid-template-columns: 1fr;
  }
}

.blueprint-canvas-container {
  background: #ffffff;
  border-radius: var(--rm-radius-lg);
  border: 1px solid rgba(226, 232, 240, 0.9);
  box-shadow: var(--rm-glass-shadow);
  overflow: hidden;
  position: relative;
  transition: var(--rm-transition);
}

.blueprint-header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.25rem;
  background: rgba(248, 250, 252, 0.85);
  border-bottom: 1px solid rgba(226, 232, 240, 0.9);
  backdrop-filter: blur(8px);
}

.room-inspector-card {
  background: var(--rm-glass-bg);
  backdrop-filter: var(--rm-glass-blur);
  border: 1px solid var(--rm-glass-border-subtle);
  border-radius: var(--rm-radius-lg);
  box-shadow: var(--rm-glass-shadow);
  overflow: hidden;
  position: sticky;
  top: 1rem;
}

.room-inspector-header {
  padding: 1.25rem 1.25rem 0.75rem 1.25rem;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
}

.room-inspector-body {
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  max-height: calc(85vh - 120px);
  overflow-y: auto;
}

.asset-chip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
  background: rgba(248, 250, 252, 0.9);
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: var(--rm-radius-md);
  font-size: 0.85rem;
  font-weight: 500;
  transition: var(--rm-transition);
}

.asset-chip:hover {
  background: #ffffff;
  border-color: var(--rm-primary-border);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);
}

.room-grid-card {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: var(--rm-glass-blur);
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: var(--rm-radius-lg);
  padding: 1.25rem;
  transition: var(--rm-transition);
  box-shadow: var(--rm-glass-shadow);
  cursor: pointer;
  position: relative;
}

.room-grid-card:hover {
  transform: translateY(-3px);
  border-color: var(--rm-primary);
  box-shadow: var(--rm-glass-shadow-hover);
}

.room-grid-card.selected {
  border-color: var(--rm-primary);
  background: rgba(238, 242, 255, 0.85);
  box-shadow: 0 0 0 2px var(--rm-primary), var(--rm-glass-shadow-hover);
}

/* =================================================================
   MODERN EXECUTIVE HEADER / NAVBAR
   ================================================================= */
.header {
  background: #ffffff !important;
  border-bottom: 1px solid rgba(226, 232, 240, 0.9) !important;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.05) !important;
  height: 56px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 0 20px 0 0 !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 1030 !important;
  transform: none !important;
  -webkit-transform: none !important;
  backface-visibility: visible !important;
  -webkit-backface-visibility: visible !important;
  transition: width 0.3s ease, background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease !important;
}

.header-left {
  background: transparent !important;
  border-right: 1px solid rgba(226, 232, 240, 0.8) !important;
  height: 56px !important;
  width: 276px !important;
  min-width: 276px !important;
  max-width: 276px !important;
  float: none !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 0 16px !important;
  margin: 0 !important;
  transition: all 0.3s ease !important;
  box-sizing: border-box !important;
}

.header-left .logo img {
  max-height: 38px !important;
  width: auto !important;
  object-fit: contain !important;
}

.header-left .logo-small img {
  max-height: 32px !important;
  width: auto !important;
  object-fit: contain !important;
}

/* Mini Sidebar Header Transitions */
.mini-sidebar .header-left {
  width: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
  padding: 0 8px !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: center !important;
}

.mini-sidebar .header-left .logo-small img {
  max-height: 26px !important;
  width: auto !important;
}

.mini-sidebar .header-left #toggle_btn {
  width: 28px !important;
  height: 28px !important;
  font-size: 14px !important;
  border-radius: 6px !important;
}

.mini-sidebar.expand-menu .header-left {
  width: 276px !important;
  min-width: 276px !important;
  max-width: 276px !important;
  padding: 0 16px !important;
  justify-content: space-between !important;
}

#toggle_btn {
  background: rgba(241, 245, 249, 0.9) !important;
  border-radius: 8px !important;
  width: 32px !important;
  height: 32px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #475569 !important;
  transition: var(--rm-transition) !important;
  text-decoration: none !important;
  flex-shrink: 0 !important;
}

#toggle_btn:hover {
  background: var(--rm-primary) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25) !important;
}

/* Header Search Bar */
.header-search-wrap {
  flex: 1 1 !important;
  max-width: 440px !important;
  margin: 0 20px !important;
  position: relative !important;
  display: flex !important;
  align-items: center !important;
}

.header-search-wrap .search-icon {
  position: absolute !important;
  left: 14px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  color: #94a3b8 !important;
  font-size: 15px !important;
  pointer-events: none !important;
  z-index: 2 !important;
}

.header-search-wrap input {
  width: 100% !important;
  height: 38px !important;
  padding: 0 44px 0 38px !important;
  border-radius: 9999px !important;
  background: rgba(241, 245, 249, 0.85) !important;
  border: 1px solid rgba(203, 213, 225, 0.8) !important;
  color: #1e293b !important;
  font-size: 0.85rem !important;
  box-shadow: none !important;
  transition: all 0.25s ease !important;
}

.header-search-wrap input:focus {
  background: #ffffff !important;
  border-color: var(--rm-primary) !important;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15) !important;
  outline: none !important;
}

.header-search-wrap .search-shortcut {
  position: absolute !important;
  right: 12px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  font-size: 11px !important;
  padding: 2px 7px !important;
  border-radius: 6px !important;
  background: rgba(203, 213, 225, 0.45) !important;
  color: #64748b !important;
  font-weight: 600 !important;
  letter-spacing: 0.02em !important;
  pointer-events: none !important;
}

/* Header Right Controls */
.header-right-controls {
  display: flex !important;
  align-items: center !important;
  gap: 14px !important;
  margin-left: auto !important;
  flex-shrink: 0 !important;
}

/* Day/Night Mode Switcher */
.dark-mode-toggle {
  background: rgba(241, 245, 249, 0.95) !important;
  border: 1px solid rgba(203, 213, 225, 0.9) !important;
  border-radius: 9999px !important;
  padding: 3px !important;
  display: inline-flex !important;
  align-items: center !important;
  position: relative !important;
  cursor: pointer !important;
  height: 34px !important;
  width: 68px !important;
  box-sizing: border-box !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  -webkit-user-select: none !important;
          user-select: none !important;
}

.dark-mode-toggle .toggle-thumb {
  position: absolute !important;
  top: 3px !important;
  left: 3px !important;
  width: 26px !important;
  height: 26px !important;
  border-radius: 50% !important;
  background: #ffffff !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2) !important;
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), background 0.25s ease !important;
  z-index: 1 !important;
}

.dark-mode-toggle.is-dark .toggle-thumb {
  transform: translateX(34px) !important;
  background: var(--rm-primary) !important;
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.5) !important;
}

.dark-mode-toggle i {
  width: 28px !important;
  height: 26px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 13px !important;
  position: relative !important;
  z-index: 2 !important;
  color: #64748b !important;
  transition: all 0.2s ease !important;
}

.dark-mode-toggle.is-light .light-mode {
  color: #f59e0b !important;
  font-weight: bold !important;
}

.dark-mode-toggle.is-dark .dark-mode {
  color: #ffffff !important;
  font-weight: bold !important;
}

[data-theme="dark"] .dark-mode-toggle {
  background: rgba(30, 41, 59, 0.9) !important;
  border-color: rgba(51, 65, 85, 0.95) !important;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.4) !important;
}

/* Executive User Profile Chip */
.header-user-chip {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 5px 12px 5px 14px !important;
  border-radius: 9999px !important;
  background: rgba(241, 245, 249, 0.75) !important;
  border: 1px solid rgba(226, 232, 240, 0.9) !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  text-decoration: none !important;
}

.header-user-chip:hover {
  background: rgba(241, 245, 249, 1) !important;
  border-color: rgba(203, 213, 225, 1) !important;
}

.header-user-chip .user-info-text {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  line-height: 1.15 !important;
}

.header-user-chip .user-name {
  font-size: 0.82rem !important;
  font-weight: 700 !important;
  color: #1e293b !important;
}

.header-user-chip .user-role-badge {
  font-size: 0.65rem !important;
  font-weight: 700 !important;
  color: var(--rm-primary) !important;
  background: rgba(79, 70, 229, 0.1) !important;
  padding: 1px 6px !important;
  border-radius: 4px !important;
  letter-spacing: 0.03em !important;
}

.header-user-chip .avatar-wrapper {
  position: relative !important;
  width: 34px !important;
  height: 34px !important;
  flex-shrink: 0 !important;
}

.header-user-chip .avatar-img {
  width: 34px !important;
  height: 34px !important;
  border-radius: 50% !important;
  object-fit: cover !important;
  border: 1.5px solid #ffffff !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
}

.header-user-chip .online-status-dot {
  position: absolute !important;
  bottom: 0 !important;
  right: 0 !important;
  width: 9px !important;
  height: 9px !important;
  border-radius: 50% !important;
  background: #10B981 !important;
  border: 1.5px solid #ffffff !important;
  box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.3) !important;
}

.header-user-chip .chevron-icon {
  font-size: 12px !important;
  color: #94a3b8 !important;
  transition: transform 0.2s ease !important;
}

/* Dropdown Menu Positioning & Styling */
.header .dropdown-menu {
  top: 50px !important;
  right: 0 !important;
  left: auto !important;
  border-radius: 14px !important;
  box-shadow: 0 12px 36px -4px rgba(15, 23, 42, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid rgba(226, 232, 240, 0.9) !important;
  background: rgba(255, 255, 255, 0.98) !important;
  backdrop-filter: blur(16px) !important;
  padding: 8px !important;
  min-width: 230px !important;
  z-index: 1050 !important;
}

/* Dark Theme Overrides for Header */
[data-theme="dark"] .header {
  background: rgba(15, 23, 42, 0.95) !important;
  border-bottom-color: rgba(51, 65, 85, 0.8) !important;
}

[data-theme="dark"] .header-left {
  border-right-color: rgba(51, 65, 85, 0.8) !important;
}

[data-theme="dark"] .header-search-wrap input {
  background: rgba(30, 41, 59, 0.8) !important;
  border-color: rgba(51, 65, 85, 0.9) !important;
  color: #f1f5f9 !important;
}

[data-theme="dark"] .header-user-chip {
  background: rgba(30, 41, 59, 0.7) !important;
  border-color: rgba(51, 65, 85, 0.8) !important;
}

[data-theme="dark"] .header-user-chip .user-name {
  color: #f1f5f9 !important;
}

[data-theme="dark"] .header .dropdown-menu {
  background: rgba(30, 41, 59, 0.98) !important;
  border-color: rgba(51, 65, 85, 0.9) !important;
}

/* =================================================================
   MODERN EXECUTIVE SIDEBAR
   ================================================================= */
.sidebar {
  background: #ffffff !important;
  border-right: 1px solid rgba(226, 232, 240, 0.9) !important;
  box-shadow: 2px 0 14px -2px rgba(15, 23, 42, 0.04) !important;
  position: fixed !important;
  top: 56px !important;
  bottom: 0 !important;
  left: 0 !important;
  width: 276px !important;
  height: calc(100vh - 56px) !important;
  z-index: 1025 !important;
  overflow: hidden !important;
  overscroll-behavior: contain !important;
  overscroll-behavior-y: contain !important;
  transform: none !important;
  -webkit-transform: none !important;
  backface-visibility: visible !important;
  -webkit-backface-visibility: visible !important;
  transition: width 0.3s ease, background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease !important;
}

.sidebar .sidebar-inner,
.sidebar [style*="overflow"] {
  overscroll-behavior: contain !important;
  overscroll-behavior-y: contain !important;
}

.sidebar-profile-card {
  background: linear-gradient(135deg, rgba(79, 70, 229, 0.06) 0%, rgba(6, 182, 212, 0.04) 100%) !important;
  border: 1px solid rgba(79, 70, 229, 0.15) !important;
  border-radius: 12px !important;
  padding: 10px 12px !important;
  margin: 10px 6px 14px 6px !important;
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.04) !important;
  transition: var(--rm-transition);
}

.sidebar-menu {
  padding: 8px 10px !important;
}

.sidebar-menu .submenu-hdr {
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.08em !important;
  color: #94a3b8 !important;
  padding: 12px 10px 6px !important;
  margin-bottom: 2px !important;
}

.sidebar-menu ul li a {
  border-radius: 10px !important;
  padding: 10px 14px !important;
  font-size: 0.88rem !important;
  font-weight: 500 !important;
  color: #475569 !important;
  display: flex !important;
  align-items: center !important;
  transition: var(--rm-transition) !important;
  margin-bottom: 2px !important;
}

.sidebar-menu ul li a i {
  font-size: 1.15rem !important;
  margin-right: 12px !important;
  color: #64748b !important;
  transition: var(--rm-transition) !important;
  background: transparent !important;
}

.sidebar-menu ul li a:hover {
  background: rgba(79, 70, 229, 0.08) !important;
  color: var(--rm-primary) !important;
  transform: translateX(3px) !important;
}

.sidebar-menu ul li a:hover i {
  color: var(--rm-primary) !important;
}

/* FIX: OVERRIDE RED TEXT ON ACTIVE ITEMS */
.sidebar .sidebar-menu ul li a.active,
.sidebar .sidebar-menu ul li a.active span,
.sidebar .sidebar-menu ul li a.active i,
.sidebar .sidebar-menu ul li.submenu > a.active,
.sidebar .sidebar-menu ul li.submenu > a.active span,
.sidebar .sidebar-menu ul li.submenu > a.active i,
.sidebar .sidebar-menu > ul li.submenu > a.active,
.sidebar .sidebar-menu > ul li.submenu > a.active span,
.sidebar .sidebar-menu > ul li.submenu > a.active i,
.sidebar .sidebar-menu > ul li.submenu > a.subdrop,
.sidebar .sidebar-menu > ul li.submenu > a.subdrop span,
.sidebar .sidebar-menu > ul li.submenu > a.subdrop i {
  color: #ffffff !important;
}

.sidebar .sidebar-menu ul li a.active,
.sidebar .sidebar-menu ul li.submenu > a.subdrop,
.sidebar .sidebar-menu > ul li.submenu > a.subdrop {
  background: var(--rm-primary-gradient) !important;
  box-shadow: 0 4px 16px rgba(79, 70, 229, 0.28) !important;
}

.sidebar .sidebar-menu ul li a.active i,
.sidebar .sidebar-menu ul li.submenu > a.subdrop i,
.sidebar .sidebar-menu > ul li.submenu > a.subdrop i {
  background: transparent !important;
  color: #ffffff !important;
}

/* FIX: REMOVE BROKEN PSEUDO-ELEMENT VERTICAL PIPES & DOTS IN SUBMENU */
.sidebar .sidebar-menu > ul li .submenu > ul li a:before,
.sidebar .sidebar-menu > ul li .submenu > ul li a:after,
.sidebar .sidebar-menu ul li.submenu ul li a:before,
.sidebar .sidebar-menu ul li.submenu ul li a:after,
.sidebar .sidebar-menu ul li.submenu > ul li a:before,
.sidebar .sidebar-menu ul li.submenu > ul li a:after {
  display: none !important;
  content: none !important;
  width: 0 !important;
  height: 0 !important;
}

/* CLEAN MODERN SUBMENU TREE */
.sidebar-menu ul li.submenu ul,
.sidebar .sidebar-menu > ul li .submenu > ul {
  padding: 4px 0 6px 0 !important;
  margin: 2px 0 4px 8px !important;
  border-left: 2px solid rgba(226, 232, 240, 0.85) !important;
}

.sidebar-menu ul li.submenu ul li a,
.sidebar .sidebar-menu > ul li .submenu > ul li a {
  padding: 7px 12px 7px 18px !important;
  margin: 2px 6px !important;
  font-size: 0.84rem !important;
  color: #64748b !important;
  border-radius: 8px !important;
  display: flex !important;
  align-items: center !important;
  transition: all 0.2s ease !important;
}

.sidebar-menu ul li.submenu ul li a:hover,
.sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: var(--rm-primary) !important;
  background: rgba(79, 70, 229, 0.08) !important;
  padding-left: 22px !important;
}

.sidebar-menu ul li.submenu ul li a.active,
.sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  background: rgba(79, 70, 229, 0.12) !important;
  color: var(--rm-primary) !important;
  font-weight: 600 !important;
  box-shadow: none !important;
}

.mini-sidebar .sidebar {
  width: 80px !important;
}

.page-wrapper {
  min-height: calc(100vh - 56px) !important;
}

.page-wrapper .content {
  padding: 24px 28px !important;
}

/* =================================================================
   COMPREHENSIVE DARK THEME SYSTEM
   ================================================================= */
[data-theme="dark"],
[data-theme="dark"] body {
  --rm-bg-main: #0B0F19;
  --rm-bg-mesh: radial-gradient(at 0% 0%, rgba(79, 70, 229, 0.15) 0px, transparent 50%),
                radial-gradient(at 100% 0%, rgba(6, 182, 212, 0.12) 0px, transparent 50%),
                radial-gradient(at 50% 100%, rgba(139, 92, 246, 0.12) 0px, transparent 50%),
                #0B0F19;
  --rm-surface: #111827;
  --rm-surface-hover: #1F2937;
  --rm-glass-bg: rgba(17, 24, 39, 0.88);
  --rm-glass-bg-hover: rgba(31, 41, 55, 0.95);
  --rm-glass-border: rgba(55, 65, 81, 0.75);
  --rm-glass-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.5), 0 4px 12px -2px rgba(0, 0, 0, 0.4);
  --rm-glass-shadow-hover: 0 20px 40px -12px rgba(0, 0, 0, 0.65), 0 8px 16px -4px rgba(0, 0, 0, 0.5);

  --rm-text-primary: #F8FAFC;
  --rm-text-secondary: #94A3B8;
  --rm-text-muted: #64748B;
  --rm-border: rgba(55, 65, 81, 0.8);
  --rm-border-light: rgba(55, 65, 81, 0.5);

  background: #0B0F19 !important;
  color: #F8FAFC !important;
}

/* Page Wrapper and Main Area */
[data-theme="dark"] .main-wrapper,
[data-theme="dark"] .page-wrapper,
[data-theme="dark"] .content {
  background: var(--rm-bg-mesh) !important;
  color: #F8FAFC !important;
}

/* Header & Sidebar in Dark Mode */
[data-theme="dark"] .header {
  background: rgba(15, 23, 42, 0.95) !important;
  border-bottom: 1px solid rgba(51, 65, 85, 0.8) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
}

[data-theme="dark"] .header-left {
  background: rgba(15, 23, 42, 0.98) !important;
  border-right: 1px solid rgba(51, 65, 85, 0.8) !important;
}

[data-theme="dark"] .header-search-wrap input {
  background: rgba(30, 41, 59, 0.85) !important;
  border-color: rgba(51, 65, 85, 0.9) !important;
  color: #F8FAFC !important;
}

[data-theme="dark"] .header-user-chip {
  background: rgba(30, 41, 59, 0.75) !important;
  border-color: rgba(51, 65, 85, 0.8) !important;
}

[data-theme="dark"] .header-user-chip .user-name {
  color: #F8FAFC !important;
}

[data-theme="dark"] .sidebar {
  background: rgba(15, 23, 42, 0.96) !important;
  border-right: 1px solid rgba(51, 65, 85, 0.8) !important;
}

[data-theme="dark"] .sidebar .sidebar-profile-card {
  background: rgba(30, 41, 59, 0.75) !important;
  border-color: rgba(51, 65, 85, 0.8) !important;
}

[data-theme="dark"] .sidebar .sidebar-profile-card h5 {
  color: #F8FAFC !important;
}

[data-theme="dark"] .sidebar .sidebar-menu > ul > li > a {
  color: #94A3B8 !important;
}

[data-theme="dark"] .sidebar .sidebar-menu > ul > li > a:hover {
  color: #FFFFFF !important;
  background: rgba(79, 70, 229, 0.2) !important;
}

[data-theme="dark"] .sidebar .sidebar-menu > ul > li > a.active {
  color: #FFFFFF !important;
  background: var(--rm-primary-gradient) !important;
}

[data-theme="dark"] .sidebar-menu .submenu-hdr {
  color: #64748B !important;
}

[data-theme="dark"] .sidebar-menu ul li.submenu ul,
[data-theme="dark"] .sidebar .sidebar-menu > ul li .submenu > ul {
  border-left-color: rgba(51, 65, 85, 0.8) !important;
}

[data-theme="dark"] .sidebar-menu ul li.submenu ul li a,
[data-theme="dark"] .sidebar .sidebar-menu > ul li .submenu > ul li a {
  color: #94A3B8 !important;
}

[data-theme="dark"] .sidebar-menu ul li.submenu ul li a:hover,
[data-theme="dark"] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {
  color: #818CF8 !important;
  background: rgba(79, 70, 229, 0.15) !important;
}

[data-theme="dark"] .sidebar-menu ul li.submenu ul li a.active,
[data-theme="dark"] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {
  color: #A5B4FC !important;
  background: rgba(79, 70, 229, 0.25) !important;
}

/* Cards & Surfaces in Dark Mode */
[data-theme="dark"] .card,
[data-theme="dark"] .rm-glass-card,
[data-theme="dark"] .rm-kpi-card {
  background: rgba(17, 24, 39, 0.88) !important;
  border-color: rgba(55, 65, 81, 0.75) !important;
  color: #F8FAFC !important;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.5) !important;
}

[data-theme="dark"] .card-header,
[data-theme="dark"] .card-footer {
  background: rgba(15, 23, 42, 0.6) !important;
  border-color: rgba(55, 65, 81, 0.75) !important;
  color: #F8FAFC !important;
}

/* Tables in Dark Mode */
[data-theme="dark"] .table {
  color: #CBD5E1 !important;
  border-color: rgba(55, 65, 81, 0.6) !important;
}

[data-theme="dark"] .table thead th {
  background: rgba(30, 41, 59, 0.9) !important;
  color: #F1F5F9 !important;
  border-color: rgba(55, 65, 81, 0.8) !important;
}

[data-theme="dark"] .table tbody td,
[data-theme="dark"] .table tbody tr {
  background: transparent !important;
  border-color: rgba(55, 65, 81, 0.5) !important;
  color: #CBD5E1 !important;
}

[data-theme="dark"] .table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: rgba(30, 41, 59, 0.45) !important;
  color: #CBD5E1 !important;
}

[data-theme="dark"] .table-hover > tbody > tr:hover > * {
  background-color: rgba(79, 70, 229, 0.12) !important;
}

/* Inputs & Form Controls in Dark Mode */
[data-theme="dark"] .form-control,
[data-theme="dark"] .form-select,
[data-theme="dark"] input,
[data-theme="dark"] select {
  background-color: rgba(30, 41, 59, 0.85) !important;
  border-color: rgba(71, 85, 105, 0.8) !important;
  color: #F8FAFC !important;
}

[data-theme="dark"] .form-control:focus,
[data-theme="dark"] .form-select:focus {
  background-color: rgba(30, 41, 59, 1) !important;
  border-color: var(--rm-primary) !important;
  color: #FFFFFF !important;
}

[data-theme="dark"] .form-control::placeholder {
  color: #64748B !important;
}

/* Text & Headings in Dark Mode */
[data-theme="dark"] h1, [data-theme="dark"] h2, [data-theme="dark"] h3,
[data-theme="dark"] h4, [data-theme="dark"] h5, [data-theme="dark"] h6,
[data-theme="dark"] .text-dark {
  color: #F8FAFC !important;
}

[data-theme="dark"] .text-muted {
  color: #94A3B8 !important;
}

[data-theme="dark"] .bg-white {
  background-color: rgba(17, 24, 39, 0.95) !important;
}

[data-theme="dark"] .bg-light {
  background-color: rgba(30, 41, 59, 0.8) !important;
}

[data-theme="dark"] .border-bottom,
[data-theme="dark"] .border-top,
[data-theme="dark"] .border-start,
[data-theme="dark"] .border-end,
[data-theme="dark"] .border {
  border-color: rgba(55, 65, 81, 0.7) !important;
}

/* Modals & Popups in Dark Mode */
[data-theme="dark"] .modal-content {
  background-color: #111827 !important;
  color: #F8FAFC !important;
  border: 1px solid rgba(55, 65, 81, 0.8) !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.7) !important;
}

[data-theme="dark"] .modal-header,
[data-theme="dark"] .modal-footer {
  border-color: rgba(55, 65, 81, 0.8) !important;
}

/* Dropdowns in Dark Mode */
[data-theme="dark"] .dropdown-menu {
  background-color: rgba(17, 24, 39, 0.95) !important;
  backdrop-filter: blur(18px) !important;
  -webkit-backdrop-filter: blur(18px) !important;
  border-color: rgba(55, 65, 81, 0.8) !important;
  color: #F8FAFC !important;
  box-shadow: 0 16px 40px -8px rgba(0, 0, 0, 0.6) !important;
}

[data-theme="dark"] .dropdown-item {
  color: #CBD5E1 !important;
}

[data-theme="dark"] .dropdown-item:hover {
  background-color: rgba(79, 70, 229, 0.2) !important;
  color: #FFFFFF !important;
}

/* =================================================================
   GLOBAL GLASSMORPHIC DROPDOWN & SELECT SYSTEM
   ================================================================= */
.dropdown-menu,
.select__menu,
.ant-select-dropdown,
.p-dropdown-panel {
  background: rgba(255, 255, 255, 0.92) !important;
  backdrop-filter: blur(18px) !important;
  -webkit-backdrop-filter: blur(18px) !important;
  border: 1px solid rgba(226, 232, 240, 0.9) !important;
  border-radius: 14px !important;
  box-shadow: 0 16px 36px -6px rgba(15, 23, 42, 0.14), 0 0 0 1px rgba(255, 255, 255, 0.7) inset !important;
  padding: 6px !important;
  z-index: 1060 !important;
}

.dropdown-item,
.p-dropdown-item {
  padding: 8px 14px !important;
  border-radius: 8px !important;
  font-size: 0.86rem !important;
  font-weight: 500 !important;
  color: #1e293b !important;
  transition: all 0.15s ease !important;
}

.dropdown-item:hover,
.dropdown-item:focus,
.p-dropdown-item:hover {
  background: rgba(79, 70, 229, 0.08) !important;
  color: var(--rm-primary) !important;
  transform: translateX(2px) !important;
}

/* =================================================================
   GLASSMORPHISM DROPDOWN SYSTEM (Universal Glass Effect for All Dropdowns)
   ================================================================= */

/* 1. GlassSelect Custom Component */
.rm-glass-select-container {
  width: 100%;
  position: relative;
  display: block;
}

.rm-glass-select-container.open {
  z-index: 1060 !important;
}

.input-group:has(.rm-glass-select-container) {
  overflow: visible !important;
}

.rm-glass-select-trigger {
  background: rgba(255, 255, 255, 0.78) !important;
  backdrop-filter: blur(14px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(14px) saturate(180%) !important;
  border: 1px solid rgba(203, 213, 225, 0.75) !important;
  color: #1e293b !important;
  font-size: 0.88rem !important;
  font-weight: 500 !important;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04), 0 0 0 1px rgba(255, 255, 255, 0.6) inset !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.rm-glass-select-trigger:hover:not(:disabled) {
  border-color: rgba(99, 102, 241, 0.65) !important;
  background: rgba(255, 255, 255, 0.92) !important;
  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.12), 0 0 0 1px rgba(255, 255, 255, 0.9) inset !important;
}

.rm-glass-select-trigger.active {
  border-color: var(--rm-primary) !important;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.18), 0 4px 12px rgba(79, 70, 229, 0.1) !important;
  background: rgba(255, 255, 255, 0.98) !important;
}

.rm-glass-select-trigger.disabled {
  background: rgba(241, 245, 249, 0.6) !important;
  border-color: rgba(226, 232, 240, 0.7) !important;
  color: #94a3b8 !important;
  cursor: not-allowed !important;
}

.rm-glass-select-trigger .rm-select-placeholder {
  color: #94a3b8 !important;
  font-weight: 400 !important;
}

.rm-glass-select-trigger .rm-select-value {
  color: #1e293b !important;
  font-weight: 600 !important;
}

.rm-glass-select-trigger .rm-select-chevron {
  font-size: 13px !important;
  color: #64748b !important;
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.rm-glass-select-trigger .rm-select-chevron.rotate {
  transform: rotate(180deg) !important;
}

.rm-glass-select-trigger .rm-select-clear-btn {
  font-size: 11px !important;
  color: #94a3b8 !important;
  padding: 2px 4px !important;
  border-radius: 4px !important;
  cursor: pointer !important;
  transition: all 0.15s ease !important;
}

.rm-glass-select-trigger .rm-select-clear-btn:hover {
  background: rgba(239, 68, 68, 0.12) !important;
  color: #ef4444 !important;
}

/* Glassmorphic Dropdown Menu Popup (Custom + Bootstrap + React-Select + System Dropdowns) */
.rm-glass-select-menu,
.dropdown-menu,
.select__menu,
.react-select__menu,
[class\$="__menu"],
[class*="-menu"] {
  background: rgba(255, 255, 255, 0.84) !important;
  backdrop-filter: blur(18px) saturate(190%) !important;
  -webkit-backdrop-filter: blur(18px) saturate(190%) !important;
  border: 1px solid rgba(255, 255, 255, 0.65) !important;
  border-radius: 14px !important;
  box-shadow: 0 16px 38px -6px rgba(15, 23, 42, 0.18), 0 0 0 1px rgba(255, 255, 255, 0.8) inset !important;
  overflow: hidden !important;
  z-index: 1070 !important;
}

.rm-glass-select-menu {
  position: absolute !important;
  top: calc(100% + 6px) !important;
  left: 0 !important;
  right: 0 !important;
  min-width: 100% !important;
  animation: rmSelectFadeDown 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards !important;
}

.rm-glass-select-menu.placement-top {
  top: auto !important;
  bottom: calc(100% + 6px) !important;
  animation: rmSelectFadeUp 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards !important;
}

@keyframes rmSelectFadeDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes rmSelectFadeUp {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.gate-pass-modal-dialog {
  max-width: 920px !important;
}

.gate-pass-modal-dialog .modal-content,
.gate-pass-modal-dialog .modal-body {
  overflow: visible !important;
}

.rm-glass-select-menu .rm-select-options-list,
.react-select__menu-list,
[class\$="__menu-list"] {
  max-height: 280px !important;
  overflow-y: auto !important;
  padding: 6px !important;
}

.rm-glass-select-menu .rm-select-options-list::-webkit-scrollbar,
.react-select__menu-list::-webkit-scrollbar,
[class\$="__menu-list"]::-webkit-scrollbar {
  width: 5px !important;
}

.rm-glass-select-menu .rm-select-options-list::-webkit-scrollbar-thumb,
.react-select__menu-list::-webkit-scrollbar-thumb,
[class\$="__menu-list"]::-webkit-scrollbar-thumb {
  background: rgba(203, 213, 225, 0.85) !important;
  border-radius: 10px !important;
}

/* Glass Select Items / Options */
.rm-glass-select-item,
.dropdown-menu .dropdown-item,
.select__option,
.react-select__option,
[class\$="__option"],
[class*="-option"] {
  padding: 9px 13px !important;
  border-radius: 8px !important;
  margin: 2px 4px !important;
  cursor: pointer !important;
  font-size: 0.86rem !important;
  color: #334155 !important;
  font-weight: 500 !important;
  transition: all 0.18s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.rm-glass-select-item:hover:not(.disabled),
.dropdown-menu .dropdown-item:hover,
.select__option:hover,
.react-select__option:hover,
.react-select__option--is-focused,
[class\$="__option--is-focused"] {
  background: rgba(79, 70, 229, 0.09) !important;
  color: var(--rm-primary, #4F46E5) !important;
  transform: translateX(3px) !important;
}

.rm-glass-select-item.selected,
.dropdown-menu .dropdown-item.active,
.select__option--is-selected,
.react-select__option--is-selected,
[class\$="__option--is-selected"] {
  background: linear-gradient(135deg, rgba(79, 70, 229, 0.95), rgba(99, 102, 241, 0.9)) !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.28) !important;
}

.rm-glass-select-item.disabled,
.dropdown-menu .dropdown-item.disabled,
.react-select__option--is-disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

/* Glass Controls / Triggers (React-Select & Form-Select) */
.react-select__control,
.select__control,
[class\$="__control"] {
  background: rgba(255, 255, 255, 0.78) !important;
  backdrop-filter: blur(14px) !important;
  -webkit-backdrop-filter: blur(14px) !important;
  border: 1.5px solid rgba(226, 232, 240, 0.85) !important;
  border-radius: 10px !important;
  min-height: 42px !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02) !important;
  transition: all 0.2s ease !important;
}

.react-select__control:hover,
.select__control:hover,
[class\$="__control"]:hover {
  border-color: rgba(79, 70, 229, 0.45) !important;
}

.react-select__control--is-focused,
.select__control--is-focused,
[class\$="__control--is-focused"] {
  border-color: #4F46E5 !important;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.16) !important;
}

.react-select__single-value,
[class\$="__single-value"] {
  color: #1e293b !important;
  font-weight: 500 !important;
}

/* Native select controls fallback glass styling */
.form-select,
select.form-control {
  background-color: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(14px) !important;
  -webkit-backdrop-filter: blur(14px) !important;
  border: 1.5px solid rgba(226, 232, 240, 0.85) !important;
  border-radius: 10px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03) !important;
  transition: all 0.2s ease !important;
}

.form-select:focus,
select.form-control:focus {
  border-color: #4F46E5 !important;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.16) !important;
}

/* Dark Mode Overrides for All Glass Dropdowns */
[data-theme="dark"] .rm-glass-select-trigger,
[data-theme="dark"] .react-select__control,
[data-theme="dark"] .form-select,
[data-theme="dark"] select.form-control {
  background: rgba(30, 41, 59, 0.82) !important;
  backdrop-filter: blur(14px) !important;
  -webkit-backdrop-filter: blur(14px) !important;
  border-color: rgba(71, 85, 105, 0.75) !important;
  color: #F8FAFC !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.06) inset !important;
}

[data-theme="dark"] .rm-glass-select-trigger:hover:not(:disabled),
[data-theme="dark"] .react-select__control:hover {
  background: rgba(30, 41, 59, 0.95) !important;
  border-color: var(--rm-primary) !important;
}

[data-theme="dark"] .rm-glass-select-trigger.active,
[data-theme="dark"] .react-select__control--is-focused {
  border-color: var(--rm-primary) !important;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.3) !important;
}

[data-theme="dark"] .rm-glass-select-trigger .rm-select-value,
[data-theme="dark"] .react-select__single-value {
  color: #F8FAFC !important;
}

[data-theme="dark"] .rm-glass-select-menu,
[data-theme="dark"] .dropdown-menu,
[data-theme="dark"] .select__menu,
[data-theme="dark"] .react-select__menu,
[data-theme="dark"] [class\$="__menu"] {
  background: rgba(17, 24, 39, 0.88) !important;
  backdrop-filter: blur(16px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(16px) saturate(180%) !important;
  border-color: rgba(255, 255, 255, 0.12) !important;
  box-shadow: 0 20px 45px -8px rgba(0, 0, 0, 0.75), 0 0 0 1px rgba(255, 255, 255, 0.08) inset !important;
}

[data-theme="dark"] .rm-glass-select-item,
[data-theme="dark"] .dropdown-menu .dropdown-item,
[data-theme="dark"] .select__option,
[data-theme="dark"] .react-select__option,
[data-theme="dark"] [class\$="__option"] {
  color: #E2E8F0 !important;
}

[data-theme="dark"] .rm-glass-select-item:hover:not(.disabled),
[data-theme="dark"] .dropdown-menu .dropdown-item:hover,
[data-theme="dark"] .select__option:hover,
[data-theme="dark"] .react-select__option:hover,
[data-theme="dark"] [class\$="__option--is-focused"] {
  background: rgba(79, 70, 229, 0.22) !important;
  color: #818CF8 !important;
}

[data-theme="dark"] .rm-glass-select-item.selected,
[data-theme="dark"] .dropdown-menu .dropdown-item.active,
[data-theme="dark"] .select__option--is-selected {
  background: rgba(79, 70, 229, 0.28) !important;
  color: #A5B4FC !important;
}

/* =================================================================
   GLOBAL TYPOGRAPHY & FONT ENHANCEMENTS
   ================================================================= */
body, html, .page-wrapper, .card, input, button, select, textarea, .form-control, .table {
  font-family: 'Plus Jakarta Sans', 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* =================================================================
   FLOATING THEME CUSTOMIZER (Moved away from middle to Bottom-Right FAB)
   ================================================================= */
.sidebar-contact {
  position: fixed !important;
  bottom: 24px !important;
  right: 24px !important;
  top: auto !important;
  left: auto !important;
  transform: none !important;
  z-index: 1045 !important;
  width: auto !important;
  height: auto !important;
  background: transparent !important;
  transition: all 0.3s ease !important;
}

.sidebar-contact .toggle-theme {
  position: static !important;
  background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%) !important;
  color: #FFFFFF !important;
  width: 48px !important;
  height: 48px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50% !important;
  box-shadow: 0 8px 24px rgba(79, 70, 229, 0.45) !important;
  cursor: pointer !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border: 2px solid rgba(255, 255, 255, 0.45) !important;
  backdrop-filter: blur(8px) !important;
}

.sidebar-contact .toggle-theme:hover {
  width: 48px !important;
  transform: scale(1.1) rotate(45deg) !important;
  background: linear-gradient(135deg, #4338CA 0%, #6D28D9 100%) !important;
  box-shadow: 0 12px 32px rgba(79, 70, 229, 0.65) !important;
}

.sidebar-contact .toggle-theme i {
  font-size: 20px !important;
  color: #FFFFFF !important;
}

/* =================================================================
   PAGE HEADERS, TITLES & BREADCRUMBS OVERHAUL
   ================================================================= */
.page-header {
  margin-bottom: 24px !important;
  padding-bottom: 12px !important;
  border-bottom: 1px solid rgba(226, 232, 240, 0.7) !important;
  transition: var(--rm-transition);
}

[data-theme="dark"] .page-header {
  border-bottom-color: rgba(51, 65, 85, 0.6) !important;
}

.page-title {
  font-size: 1.3rem !important;
  font-weight: 800 !important;
  letter-spacing: -0.025em !important;
  color: var(--rm-text-primary) !important;
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  margin-bottom: 0 !important;
}

.head-icons a,
.head-icons button {
  width: 36px !important;
  height: 36px !important;
  border-radius: 10px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: rgba(255, 255, 255, 0.8) !important;
  border: 1px solid rgba(226, 232, 240, 0.9) !important;
  color: var(--rm-text-secondary) !important;
  backdrop-filter: blur(8px) !important;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04) !important;
  transition: all 0.2s ease !important;
  text-decoration: none !important;
}

.head-icons a:hover,
.head-icons button:hover {
  background: #ffffff !important;
  border-color: var(--rm-primary) !important;
  color: var(--rm-primary) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.15) !important;
}

[data-theme="dark"] .head-icons a,
[data-theme="dark"] .head-icons button {
  background: rgba(30, 41, 59, 0.85) !important;
  border-color: rgba(51, 65, 85, 0.85) !important;
  color: #94A3B8 !important;
}

[data-theme="dark"] .head-icons a:hover,
[data-theme="dark"] .head-icons button:hover {
  background: rgba(51, 65, 85, 1) !important;
  color: #FFFFFF !important;
  border-color: var(--rm-primary) !important;
}

/* =================================================================
   MODERN SEGMENTED TABS (Replacing Dated Red Underlines)
   ================================================================= */
.nav-tabs,
.booking-tabs,
ul.nav.nav-tabs {
  border-bottom: none !important;
  background: rgba(241, 245, 249, 0.8) !important;
  padding: 5px !important;
  border-radius: 14px !important;
  display: inline-flex !important;
  gap: 5px !important;
  border: 1px solid rgba(226, 232, 240, 0.9) !important;
  margin-bottom: 22px !important;
  backdrop-filter: blur(10px) !important;
  flex-wrap: wrap !important;
}

.nav-tabs .nav-item {
  margin-bottom: 0 !important;
}

.nav-tabs .nav-link,
.booking-tabs a,
.booking-tabs button {
  border: none !important;
  border-radius: 10px !important;
  padding: 9px 20px !important;
  font-weight: 600 !important;
  font-size: 0.88rem !important;
  color: #64748B !important;
  background: transparent !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 7px !important;
  text-decoration: none !important;
  cursor: pointer !important;
}

.nav-tabs .nav-link:hover,
.booking-tabs a:hover {
  color: var(--rm-primary) !important;
  background: rgba(255, 255, 255, 0.7) !important;
  transform: translateY(-1px);
}

.nav-tabs .nav-link.active,
.booking-tabs a.active,
.booking-tabs .active {
  background: #FFFFFF !important;
  color: var(--rm-primary) !important;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08), 0 0 0 1px rgba(79, 70, 229, 0.1) !important;
  border-bottom: none !important;
}

/* Dark Mode Segmented Tabs */
[data-theme="dark"] .nav-tabs,
[data-theme="dark"] .booking-tabs,
[data-theme="dark"] ul.nav.nav-tabs {
  background: rgba(30, 41, 59, 0.75) !important;
  border-color: rgba(51, 65, 85, 0.85) !important;
}

[data-theme="dark"] .nav-tabs .nav-link,
[data-theme="dark"] .booking-tabs a {
  color: #94A3B8 !important;
}

[data-theme="dark"] .nav-tabs .nav-link:hover,
[data-theme="dark"] .booking-tabs a:hover {
  color: #FFFFFF !important;
  background: rgba(51, 65, 85, 0.7) !important;
}

[data-theme="dark"] .nav-tabs .nav-link.active,
[data-theme="dark"] .booking-tabs a.active,
[data-theme="dark"] .booking-tabs .active {
  background: var(--rm-primary-gradient) !important;
  color: #FFFFFF !important;
  box-shadow: 0 4px 16px rgba(79, 70, 229, 0.45) !important;
  border-bottom: none !important;
}

/* =================================================================
   UNIVERSAL SOFT STATUS BADGES (High-End & Accessible)
   ================================================================= */
.badge,
.badge-status,
td .badge,
.table .badge {
  font-family: inherit !important;
  padding: 5px 12px !important;
  border-radius: 9999px !important;
  font-size: 0.74rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.04em !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 5px !important;
  line-height: 1.35 !important;
  text-transform: uppercase !important;
  border: 1px solid transparent !important;
  box-shadow: none !important;
  transition: all 0.2s ease !important;
}

/* Success / Approved / Active / Completed */
.badge-success,
.badge-soft-success,
.badge.bg-success,
.badge.bg-outline-success {
  background: rgba(16, 185, 129, 0.13) !important;
  color: #059669 !important;
  border-color: rgba(16, 185, 129, 0.3) !important;
}

/* Danger / Expired / Rejected / Cancelled */
.badge-danger,
.badge-soft-danger,
.badge.bg-danger,
.badge.bg-outline-danger {
  background: rgba(244, 63, 94, 0.13) !important;
  color: #E11D48 !important;
  border-color: rgba(244, 63, 94, 0.3) !important;
}

/* Warning / Pending / Review */
.badge-warning,
.badge-soft-warning,
.badge.bg-warning,
.badge.bg-outline-warning {
  background: rgba(245, 158, 11, 0.13) !important;
  color: #D97706 !important;
  border-color: rgba(245, 158, 11, 0.3) !important;
}

/* Info / Planned / Scheduled */
.badge-info,
.badge-soft-info,
.badge.bg-info,
.badge.bg-outline-info {
  background: rgba(14, 165, 233, 0.13) !important;
  color: #0284C7 !important;
  border-color: rgba(14, 165, 233, 0.3) !important;
}

/* Primary / Recurring / Sudden / Special */
.badge-primary,
.badge-soft-primary,
.badge.bg-primary,
.badge.bg-outline-primary {
  background: rgba(79, 70, 229, 0.13) !important;
  color: #4F46E5 !important;
  border-color: rgba(79, 70, 229, 0.3) !important;
}

/* Dark Mode Badges (Luminescent soft glows) */
[data-theme="dark"] .badge-success,
[data-theme="dark"] .badge-soft-success,
[data-theme="dark"] .badge.bg-success {
  background: rgba(16, 185, 129, 0.2) !important;
  color: #34D399 !important;
  border-color: rgba(16, 185, 129, 0.4) !important;
}

[data-theme="dark"] .badge-danger,
[data-theme="dark"] .badge-soft-danger,
[data-theme="dark"] .badge.bg-danger {
  background: rgba(244, 63, 94, 0.2) !important;
  color: #FB7185 !important;
  border-color: rgba(244, 63, 94, 0.4) !important;
}

[data-theme="dark"] .badge-warning,
[data-theme="dark"] .badge-soft-warning,
[data-theme="dark"] .badge.bg-warning {
  background: rgba(245, 158, 11, 0.2) !important;
  color: #FBBF24 !important;
  border-color: rgba(245, 158, 11, 0.4) !important;
}

[data-theme="dark"] .badge-info,
[data-theme="dark"] .badge-soft-info,
[data-theme="dark"] .badge.bg-info {
  background: rgba(14, 165, 233, 0.2) !important;
  color: #38BDF8 !important;
  border-color: rgba(14, 165, 233, 0.4) !important;
}

[data-theme="dark"] .badge-primary,
[data-theme="dark"] .badge-soft-primary,
[data-theme="dark"] .badge.bg-primary {
  background: rgba(79, 70, 229, 0.25) !important;
  color: #A5B4FC !important;
  border-color: rgba(79, 70, 229, 0.45) !important;
}

/* =================================================================
   ACTION BUTTONS & CHIPS IN DATA TABLES
   ================================================================= */
.action-table-data,
.table-action-btns {
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
}

.action-table-data a,
.table-action-btn,
td .btn-icon,
td .btn-action,
td a.btn-primary,
td a.btn-info {
  width: 34px !important;
  height: 34px !important;
  border-radius: 9px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: rgba(79, 70, 229, 0.08) !important;
  color: var(--rm-primary) !important;
  border: 1px solid rgba(79, 70, 229, 0.2) !important;
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1) !important;
  cursor: pointer !important;
  text-decoration: none !important;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04) !important;
  padding: 0 !important;
}

.action-table-data a:hover,
.table-action-btn:hover,
td a.btn-primary:hover,
td a.btn-info:hover {
  background: var(--rm-primary-gradient) !important;
  color: #FFFFFF !important;
  border-color: transparent !important;
  transform: translateY(-2px) scale(1.08) !important;
  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.38) !important;
}

[data-theme="dark"] .action-table-data a,
[data-theme="dark"] .table-action-btn,
[data-theme="dark"] td a.btn-primary,
[data-theme="dark"] td a.btn-info {
  background: rgba(30, 41, 59, 0.95) !important;
  color: #818CF8 !important;
  border-color: rgba(55, 65, 81, 0.85) !important;
}

[data-theme="dark"] .action-table-data a:hover,
[data-theme="dark"] .table-action-btn:hover,
[data-theme="dark"] td a.btn-primary:hover,
[data-theme="dark"] td a.btn-info:hover {
  background: var(--rm-primary-gradient) !important;
  color: #FFFFFF !important;
  border-color: transparent !important;
  box-shadow: 0 6px 18px rgba(79, 70, 229, 0.5) !important;
}

/* =================================================================
   SLEEK MODERN PAGINATION
   ================================================================= */
.pagination,
.ant-pagination,
.custom-pagination {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 6px !important;
  margin-top: 20px !important;
  padding: 8px 0 !important;
  list-style: none !important;
}

.page-item .page-link,
.ant-pagination-item,
.ant-pagination-prev button,
.ant-pagination-next button,
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link,
.custom-pagination button {
  min-width: 36px !important;
  height: 36px !important;
  padding: 0 14px !important;
  border-radius: 9px !important;
  border: 1px solid rgba(226, 232, 240, 0.9) !important;
  background: #FFFFFF !important;
  color: #475569 !important;
  font-size: 0.85rem !important;
  font-weight: 600 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: all 0.2s ease !important;
  text-decoration: none !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
}

.page-item .page-link:hover,
.ant-pagination-item:hover,
.ant-pagination-item-link:hover,
.custom-pagination button:hover:not(:disabled) {
  border-color: var(--rm-primary) !important;
  color: var(--rm-primary) !important;
  background: rgba(79, 70, 229, 0.06) !important;
  transform: translateY(-1px) !important;
}

.page-item.active .page-link,
.ant-pagination-item-active,
.ant-pagination-item-active a {
  background: var(--rm-primary-gradient) !important;
  border-color: transparent !important;
  color: #FFFFFF !important;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.35) !important;
}

[data-theme="dark"] .page-item .page-link,
[data-theme="dark"] .ant-pagination-item,
[data-theme="dark"] .ant-pagination-prev button,
[data-theme="dark"] .ant-pagination-next button,
[data-theme="dark"] .ant-pagination-prev .ant-pagination-item-link,
[data-theme="dark"] .ant-pagination-next .ant-pagination-item-link,
[data-theme="dark"] .custom-pagination button {
  background: rgba(30, 41, 59, 0.85) !important;
  border-color: rgba(51, 65, 85, 0.85) !important;
  color: #94A3B8 !important;
}

[data-theme="dark"] .page-item .page-link:hover,
[data-theme="dark"] .ant-pagination-item:hover,
[data-theme="dark"] .custom-pagination button:hover:not(:disabled) {
  color: #FFFFFF !important;
  background: rgba(51, 65, 85, 0.95) !important;
  border-color: var(--rm-primary) !important;
}

[data-theme="dark"] .page-item.active .page-link,
[data-theme="dark"] .ant-pagination-item-active {
  background: var(--rm-primary-gradient) !important;
  border-color: transparent !important;
  color: #FFFFFF !important;
  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.5) !important;
}

/* =================================================================
   MODERN SWEETALERT2 STYLING (Glassmorphic Popups)
   ================================================================= */
.swal2-popup {
  border-radius: 20px !important;
  padding: 24px 28px !important;
  border: 1px solid rgba(226, 232, 240, 0.9) !important;
  box-shadow: 0 25px 65px -12px rgba(15, 23, 42, 0.25) !important;
  background: rgba(255, 255, 255, 0.98) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  font-family: inherit !important;
}

.swal2-title {
  font-size: 1.35rem !important;
  font-weight: 700 !important;
  color: #0F172A !important;
  margin-bottom: 8px !important;
}

.swal2-html-container {
  font-size: 0.92rem !important;
  color: #475569 !important;
  line-height: 1.55 !important;
}

.swal2-actions {
  gap: 12px !important;
  margin-top: 24px !important;
}

.swal2-confirm {
  background: var(--rm-primary-gradient) !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  padding: 10px 24px !important;
  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.35) !important;
  border: none !important;
  transition: all 0.2s ease !important;
}

.swal2-confirm:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 18px rgba(79, 70, 229, 0.45) !important;
}

.swal2-cancel {
  background: #F1F5F9 !important;
  color: #475569 !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  padding: 10px 24px !important;
  border: 1px solid #E2E8F0 !important;
  transition: all 0.2s ease !important;
}

.swal2-cancel:hover {
  background: #E2E8F0 !important;
  color: #0F172A !important;
}

[data-theme="dark"] .swal2-popup {
  background: rgba(17, 24, 39, 0.96) !important;
  border-color: rgba(55, 65, 81, 0.85) !important;
  box-shadow: 0 25px 65px -12px rgba(0, 0, 0, 0.8) !important;
  color: #F8FAFC !important;
}

[data-theme="dark"] .swal2-title {
  color: #F8FAFC !important;
}

[data-theme="dark"] .swal2-html-container {
  color: #94A3B8 !important;
}

[data-theme="dark"] .swal2-cancel {
  background: rgba(30, 41, 59, 0.9) !important;
  color: #CBD5E1 !important;
  border-color: rgba(55, 65, 81, 0.8) !important;
}

/* =================================================================
   GOOGLE MAPS DARK MODE STYLING
   ================================================================= */
[data-theme="dark"] .google-map-container,
[data-theme="dark"] .gm-style > div:first-child > div:first-child {
  filter: invert(90%) hue-rotate(180deg) contrast(90%) brightness(95%);
}

[data-theme="dark"] .gm-style-iw {
  background: #111827 !important;
  color: #F8FAFC !important;
  border-radius: 12px !important;
}

/* =================================================================
   HEADER LOGO & COLLAPSE BUTTON FIXES FOR DARK MODE
   ================================================================= */
[data-theme="dark"] .header-left #toggle_btn {
  background: rgba(30, 41, 59, 0.9) !important;
  color: #94A3B8 !important;
  border: 1px solid rgba(51, 65, 85, 0.8) !important;
}

[data-theme="dark"] .header-left #toggle_btn:hover {
  background: var(--rm-primary) !important;
  color: #FFFFFF !important;
  border-color: transparent !important;
}

/* Ensure clean logo contrast */
.logo img, .logo-small img {
  transition: filter 0.3s ease;
}

[data-theme="dark"] .logo-small img {
  filter: brightness(1.2);
}

/* =================================================================
   STAT CARDS & KPI WIDGET OVERHAULS (For Booking Dashboard, etc.)
   ================================================================= */
.stat-card {
  background: var(--rm-glass-bg) !important;
  backdrop-filter: var(--rm-glass-blur) !important;
  -webkit-backdrop-filter: var(--rm-glass-blur) !important;
  border: 1px solid var(--rm-glass-border) !important;
  border-radius: var(--rm-radius-lg) !important;
  box-shadow: var(--rm-glass-shadow) !important;
  color: var(--rm-text-primary) !important;
  transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1) !important;
  cursor: pointer !important;
  position: relative !important;
  overflow: hidden !important;
}

.stat-card:hover {
  transform: translateY(-5px) !important;
  box-shadow: var(--rm-glass-shadow-hover) !important;
  border-color: rgba(79, 70, 229, 0.3) !important;
}

[data-theme="dark"] .stat-card {
  background: rgba(17, 24, 39, 0.9) !important;
  border-color: rgba(55, 65, 81, 0.8) !important;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.6) !important;
  color: #F8FAFC !important;
}

[data-theme="dark"] .stat-card h3,
[data-theme="dark"] .stat-card h4,
[data-theme="dark"] .stat-card h5,
[data-theme="dark"] .stat-card p,
[data-theme="dark"] .stat-card span,
[data-theme="dark"] .stat-card .text-2xl,
[data-theme="dark"] .stat-card .font-bold {
  color: #F8FAFC !important;
}

[data-theme="dark"] .stat-card .text-gray-500,
[data-theme="dark"] .stat-card .text-muted {
  color: #94A3B8 !important;
}

/* =================================================================
   CHART & APEXCHARTS OVERHAUL FOR DARK MODE
   ================================================================= */
[data-theme="dark"] .apexcharts-canvas text {
  fill: #94A3B8 !important;
}

[data-theme="dark"] .apexcharts-tooltip {
  background: rgba(17, 24, 39, 0.96) !important;
  border: 1px solid rgba(55, 65, 81, 0.85) !important;
  color: #F8FAFC !important;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5) !important;
}

[data-theme="dark"] .apexcharts-tooltip-title {
  background: rgba(30, 41, 59, 0.95) !important;
  border-bottom: 1px solid rgba(55, 65, 81, 0.85) !important;
  color: #F8FAFC !important;
}

[data-theme="dark"] .apexcharts-gridline {
  stroke: rgba(55, 65, 81, 0.5) !important;
}

/* =================================================================
   MODAL & OFFCANVAS OVERHAUL FOR DARK MODE
   ================================================================= */
[data-theme="dark"] .modal-backdrop {
  opacity: 0.75 !important;
}

[data-theme="dark"] .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%) !important;
}

[data-theme="dark"] .offcanvas {
  background: rgba(17, 24, 39, 0.96) !important;
  color: #F8FAFC !important;
  border-color: rgba(55, 65, 81, 0.85) !important;
}



`, "",{"version":3,"sources":["webpack://./src/style/css/rm-theme.css"],"names":[],"mappings":"AAAA;;;;sEAIsE;;AAEtE;EACE;;oEAEkE;EAClE,qBAAqB,iBAAiB,mBAAmB;EACzD,2BAA2B;EAC3B,2CAA2C;EAC3C,4CAA4C;EAC5C,wEAAwE;EACxE,0CAA0C;;EAE1C,uBAAuB,eAAe,eAAe;EACrD,6BAA6B;EAC7B,6CAA6C;EAC7C,0EAA0E;;EAE1E,2BAA2B;EAC3B,uEAAuE;;EAEvE;;oEAEkE;EAClE,qBAAqB,iBAAiB,YAAY;EAClD,4CAA4C;EAC5C,6CAA6C;EAC7C,wEAAwE;;EAExE,qBAAqB,iBAAiB,UAAU;EAChD,4CAA4C;EAC5C,6CAA6C;EAC7C,wEAAwE;;EAExE,oBAAoB,kBAAkB,aAAa;EACnD,0CAA0C;EAC1C,2CAA2C;EAC3C,uEAAuE;;EAEvE,kBAAkB,oBAAoB,aAAa;EACnD,wCAAwC;EACxC,yCAAyC;EACzC,qEAAqE;;EAErE;;oEAEkE;EAClE,qBAAqB,iBAAiB,kCAAkC;EACxE;;;wBAGsB;EACtB,qBAAqB;;EAErB,wCAAwC;EACxC,8CAA8C;EAC9C,2CAA2C;EAC3C,mDAAmD;EACnD,2BAA2B;EAC3B,iGAAiG;EACjG,yGAAyG;;EAEzG;;oEAEkE;EAClE,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;;EAExB;;oEAEkE;EAClE,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB;EACxB,uDAAuD;AACzD;;AAEA;;sEAEsE;AACtE;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;sEAEsE;AACtE;EACE,yCAAyC;EACzC,gDAAgD;EAChD,wDAAwD;EACxD,mDAAmD;EACnD,6CAA6C;EAC7C,6CAA6C;EAC7C,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sFAAsF;EACtF,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,mDAAmD;EACnD,+CAA+C;AACjD;;AAEA;;sEAEsE;AACtE;EACE,qFAAqF;EACrF,6CAA6C;EAC7C,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iGAAiG;EACjG,8BAA8B;EAC9B,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kFAAkF;EAClF,oBAAoB;AACtB;;AAEA;;;;;;EAME,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,qDAAqD;EACrD,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;sEAEsE;AACtE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,gCAAgC;EAChC,2CAA2C;EAC3C,qCAAqC;EACrC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;sEAEsE;AACtE;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC,8BAA8B;EAC9B,qCAAqC;EACrC,wCAAwC;EACxC,kCAAkC;EAClC,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,kCAAkC;EAClC,qCAAqC;EACrC,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;sEAEsE;AACtE;EACE;IACE,aAAa;IACb,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;sEAEsE;AACtE;EACE,6CAA6C;EAC7C,2BAA2B;EAC3B,2CAA2C;EAC3C,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,mCAAmC;AACrC;;AAEA;EACE,iDAAiD;EACjD,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;;sEAEsE;AACtE;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,6DAA6D;EAC7D,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;AACnC;;AAEA,mBAAmB;AACnB;;;EAGE,iDAAiD;EACjD,oCAAoC;EACpC,yBAAyB;EACzB,yDAAyD;AAC3D;;AAEA;;;EAGE,wEAAwE;EACxE,yBAAyB;EACzB,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA,qBAAqB;AACrB;EACE,mDAAmD;EACnD,oCAAoC;EACpC,yBAAyB;EACzB,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA,mBAAmB;AACnB;EACE,iDAAiD;EACjD,oCAAoC;EACpC,yBAAyB;EACzB,0DAA0D;AAC5D;;AAEA;EACE,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA,kBAAkB;AAClB;EACE,gDAAgD;EAChD,oCAAoC;EACpC,yBAAyB;EACzB,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA,mBAAmB;AACnB;EACE,iDAAiD;EACjD,oCAAoC;EACpC,yBAAyB;EACzB,0DAA0D;AAC5D;;AAEA;EACE,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA,gBAAgB;AAChB;EACE,8CAA8C;EAC9C,oCAAoC;EACpC,yBAAyB;EACzB,yDAAyD;AAC3D;;AAEA,oBAAoB;AACpB;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,iDAAiD;EACjD,yBAAyB;EACzB,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA;EACE,gCAAgC;EAChC,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,oCAAoC;EACpC,0CAA0C;EAC1C,aAAa;AACf;;AAEA;;EAEE,mCAAmC;EACnC,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;;sEAEsE;AACtE;;;;EAIE,kCAAkC;EAClC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,wCAAwC;AACxC;;EAEE,kCAAkC;EAClC,wCAAwC;EACxC,oCAAoC;EACpC,4BAA4B;EAC5B,WAAW;AACb;;AAEA,iBAAiB;AACjB;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,2CAA2C;EAC3C,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;;EAEE,6BAA6B;EAC7B,iCAAiC;EACjC,6DAA6D;EAC7D,yBAAyB;EACzB,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA,wBAAwB;AACxB;;EAEE,8CAA8C;AAChD;;AAEA,4BAA4B;AAC5B;EACE,yCAAyC;EACzC,gDAAgD;EAChD,wDAAwD;EACxD,mDAAmD;EACnD,6CAA6C;EAC7C,6CAA6C;EAC7C,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;EAC3B,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,iDAAiD;EACjD,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;;sEAEsE;AACtE;EACE,yCAAyC;EACzC,gDAAgD;EAChD,wDAAwD;EACxD,mDAAmD;EACnD,6CAA6C;EAC7C,6CAA6C;EAC7C,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kCAAkC;EAClC,4DAA4D;EAC5D,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;sEAEsE;AACtE;;EAEE,8BAA8B;EAC9B,sCAAsC;EACtC,6BAA6B;EAC7B,4BAA4B;EAC5B,oCAAoC;EACpC,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;;EAEE,0CAA0C;EAC1C,wDAAwD;EACxD,oCAAoC;AACtC;;AAEA;;sEAEsE;AACtE;EACE,+CAA+C;EAC/C,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;EAC9B,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,8CAA8C;EAC9C,mCAAmC;EACnC,qDAAqD;AACvD;;AAEA;;EAEE,6CAA6C;EAC7C,kCAAkC;EAClC,oDAAoD;AACtD;;AAEA;;EAEE,8CAA8C;EAC9C,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;;EAEE,2CAA2C;EAC3C,gCAAgC;EAChC,kDAAkD;AACpD;;AAEA;;EAEE,8CAA8C;EAC9C,mCAAmC;EACnC,qDAAqD;AACvD;;AAEA;;sEAEsE;AACtE;EACE,6CAA6C;EAC7C,gDAAgD;EAChD,sCAAsC;EACtC,mDAAmD;EACnD,+DAA+D;EAC/D,gBAAgB;AAClB;;AAEA;EACE,4DAA4D;EAC5D,6BAA6B;AAC/B;;AAEA;EACE,yDAAyD;EACzD,6BAA6B;AAC/B;;AAEA;;sEAEsE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,+CAA+C;EAC/C,kCAAkC;EAClC,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,oCAAoC;EACpC,+BAA+B;EAC/B,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB;EACxB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;EAC1C,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,qCAAqC;EACrC,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,+CAA+C;EAC/C,kCAAkC;EAClC,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,oCAAoC;EACpC,0CAA0C;EAC1C,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,0CAA0C;EAC1C,kCAAkC;EAClC,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,qEAAqE;AACvE;;AAEA;;sEAEsE;AACtE;EACE,8BAA8B;EAC9B,4DAA4D;EAC5D,wDAAwD;EACxD,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,0BAA0B;EAC1B,kCAAkC;EAClC,uCAAuC;EACvC,+CAA+C;EAC/C,6GAA6G;AAC/G;;AAEA;EACE,kCAAkC;EAClC,2DAA2D;EAC3D,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,0BAA0B;EAC1B,oBAAoB;EACpB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,8BAA8B;EAC9B,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,+CAA+C;EAC/C,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,2CAA2C;EAC3C,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,yDAAyD;AAC3D;;AAEA,sBAAsB;AACtB;EACE,oBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,gCAAgC;EAChC,gDAAgD;EAChD,qDAAqD;EACrD,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,wDAAwD;EACxD,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,gDAAgD;EAChD,yBAAyB;EACzB,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA,0BAA0B;AAC1B;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,gDAAgD;EAChD,qDAAqD;EACrD,gCAAgC;EAChC,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,iCAAiC;EACjC,6DAA6D;EAC7D,0DAA0D;EAC1D,oCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,mDAAmD;EACnD,0FAA0F;EAC1F,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;EAC5C,+CAA+C;EAC/C,yDAAyD;AAC3D;;AAEA,gCAAgC;AAChC;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,gDAAgD;EAChD,qDAAqD;EACrD,0BAA0B;EAC1B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,mCAAmC;EACnC,6CAA6C;EAC7C,2BAA2B;EAC3B,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,sCAAsC;EACtC,mDAAmD;AACrD;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,sCAAsC;EACtC,wDAAwD;AAC1D;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA,wCAAwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;EAC9B,6FAA6F;EAC7F,qDAAqD;EACrD,gDAAgD;EAChD,sCAAsC;EACtC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;;sEAEsE;AACtE;EACE,8BAA8B;EAC9B,2DAA2D;EAC3D,6DAA6D;EAC7D,0BAA0B;EAC1B,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,wBAAwB;EACxB,2BAA2B;EAC3B,uCAAuC;EACvC,yCAAyC;EACzC,0BAA0B;EAC1B,kCAAkC;EAClC,uCAAuC;EACvC,+CAA+C;EAC/C,6GAA6G;AAC/G;;AAEA;;EAEE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,wGAAwG;EACxG,oDAAoD;EACpD,8BAA8B;EAC9B,6BAA6B;EAC7B,oCAAoC;EACpC,wDAAwD;EACxD,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,oCAAoC;EACpC,iCAAiC;EACjC,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,8CAA8C;EAC9C,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,2CAA2C;AAC3C;;;;;;;;;;;;EAYE,yBAAyB;AAC3B;;AAEA;;;EAGE,iDAAiD;EACjD,yDAAyD;AAC3D;;AAEA;;;EAGE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA,uEAAuE;AACvE;;;;;;EAME,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;;EAEE,+BAA+B;EAC/B,gCAAgC;EAChC,2DAA2D;AAC7D;;AAEA;;EAEE,qCAAqC;EACrC,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;;EAEE,mCAAmC;EACnC,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;;EAEE,8CAA8C;EAC9C,mCAAmC;EACnC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;sEAEsE;AACtE;;EAEE,qBAAqB;EACrB;;;uBAGqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,qCAAqC;EACrC,2CAA2C;EAC3C,yCAAyC;EACzC,2FAA2F;EAC3F,kGAAkG;;EAElG,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;EACxB,kCAAkC;EAClC,wCAAwC;;EAExC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;;;EAGE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,6CAA6C;EAC7C,yDAAyD;EACzD,oDAAoD;AACtD;;AAEA;EACE,6CAA6C;EAC7C,wDAAwD;AAC1D;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,wDAAwD;AAC1D;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,mDAAmD;AACrD;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;;EAEE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA,kCAAkC;AAClC;;;EAGE,6CAA6C;EAC7C,+CAA+C;EAC/C,yBAAyB;EACzB,2DAA2D;AAC7D;;AAEA;;EAEE,4CAA4C;EAC5C,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;;EAEE,kCAAkC;EAClC,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;AACtD;;AAEA,wCAAwC;AACxC;;;;EAIE,mDAAmD;EACnD,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;;EAEE,gDAAgD;EAChD,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;;;;EAKE,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kDAAkD;EAClD,2DAA2D;AAC7D;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA,2BAA2B;AAC3B;EACE,mDAAmD;EACnD,sCAAsC;EACtC,8CAA8C;EAC9C,8CAA8C;EAC9C,yBAAyB;EACzB,0DAA0D;AAC5D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;;sEAEsE;AACtE;;;;EAIE,gDAAgD;EAChD,sCAAsC;EACtC,8CAA8C;EAC9C,qDAAqD;EACrD,8BAA8B;EAC9B,wGAAwG;EACxG,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;;;EAGE,8CAA8C;EAC9C,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;;sEAEsE;;AAEtE,oCAAoC;AACpC;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gDAAgD;EAChD,qDAAqD;EACrD,6DAA6D;EAC7D,sDAAsD;EACtD,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,iGAAiG;EACjG,6DAA6D;AAC/D;;AAEA;EACE,iDAAiD;EACjD,gDAAgD;EAChD,mGAAmG;AACrG;;AAEA;EACE,0CAA0C;EAC1C,2FAA2F;EAC3F,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;EAC/C,iDAAiD;EACjD,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mEAAmE;AACrE;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA,4FAA4F;AAC5F;;;;;;EAME,gDAAgD;EAChD,qDAAqD;EACrD,6DAA6D;EAC7D,sDAAsD;EACtD,8BAA8B;EAC9B,wGAAwG;EACxG,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,mFAAmF;AACrF;;AAEA;EACE,oBAAoB;EACpB,mCAAmC;EACnC,iFAAiF;AACnF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;;EAGE,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;EAGE,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA,iCAAiC;AACjC;;;;;;EAME,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,6DAA6D;AAC/D;;AAEA;;;;;;EAME,8CAA8C;EAC9C,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;;;;;EAKE,gGAAgG;EAChG,yBAAyB;EACzB,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;;;EAGE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,2DAA2D;AAC3D;;;EAGE,gDAAgD;EAChD,sCAAsC;EACtC,8CAA8C;EAC9C,wDAAwD;EACxD,8BAA8B;EAC9B,2BAA2B;EAC3B,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;;;EAGE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;;EAEE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,kDAAkD;AAClD;;EAEE,qDAAqD;EACrD,sCAAsC;EACtC,8CAA8C;EAC9C,wDAAwD;EACxD,8BAA8B;EAC9B,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA;;EAEE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA,gDAAgD;AAChD;;;;EAIE,6CAA6C;EAC7C,sCAAsC;EACtC,8CAA8C;EAC9C,gDAAgD;EAChD,yBAAyB;EACzB,+FAA+F;AACjG;;AAEA;;EAEE,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;;EAEE,0CAA0C;EAC1C,uDAAuD;AACzD;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,6CAA6C;EAC7C,qDAAqD;EACrD,6DAA6D;EAC7D,kDAAkD;EAClD,sGAAsG;AACxG;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;;;EAGE,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;;sEAEsE;AACtE;EACE,uHAAuH;EACvH,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;sEAEsE;AACtE;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,wEAAwE;EACxE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,yDAAyD;EACzD,0BAA0B;EAC1B,4DAA4D;EAC5D,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;EAC9C,wEAAwE;EACxE,0DAA0D;AAC5D;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;sEAEsE;AACtE;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,4DAA4D;EAC5D,gCAAgC;AAClC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,mCAAmC;EACnC,wCAAwC;EACxC,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,+CAA+C;EAC/C,qDAAqD;EACrD,0CAA0C;EAC1C,qCAAqC;EACrC,uDAAuD;EACvD,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;EAC9B,0CAA0C;EAC1C,mCAAmC;EACnC,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA;;EAEE,6CAA6C;EAC7C,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;;EAEE,0CAA0C;EAC1C,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;;sEAEsE;AACtE;;;EAGE,8BAA8B;EAC9B,+CAA+C;EAC/C,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;EACnB,qDAAqD;EACrD,8BAA8B;EAC9B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;EAGE,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,kCAAkC;EAClC,4DAA4D;EAC5D,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;;EAEE,mCAAmC;EACnC,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;;;EAGE,8BAA8B;EAC9B,mCAAmC;EACnC,0FAA0F;EAC1F,8BAA8B;AAChC;;AAEA,6BAA6B;AAC7B;;;EAGE,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;;;EAGE,iDAAiD;EACjD,yBAAyB;EACzB,yDAAyD;EACzD,8BAA8B;AAChC;;AAEA;;sEAEsE;AACtE;;;;EAIE,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;EAC5B,oCAAoC;EACpC,wCAAwC;EACxC,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA,4CAA4C;AAC5C;;;;EAIE,+CAA+C;EAC/C,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA,4CAA4C;AAC5C;;;;EAIE,8CAA8C;EAC9C,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA,+BAA+B;AAC/B;;;;EAIE,+CAA+C;EAC/C,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA,+BAA+B;AAC/B;;;;EAIE,+CAA+C;EAC/C,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA,2CAA2C;AAC3C;;;;EAIE,8CAA8C;EAC9C,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA,8CAA8C;AAC9C;;;EAGE,8CAA8C;EAC9C,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;;;EAGE,6CAA6C;EAC7C,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;;;EAGE,8CAA8C;EAC9C,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;;;EAGE,8CAA8C;EAC9C,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;;;EAGE,8CAA8C;EAC9C,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;;sEAEsE;AACtE;;EAEE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;;;;;EAME,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,8CAA8C;EAC9C,mCAAmC;EACnC,mDAAmD;EACnD,6DAA6D;EAC7D,0BAA0B;EAC1B,gCAAgC;EAChC,uDAAuD;EACvD,qBAAqB;AACvB;;AAEA;;;;EAIE,iDAAiD;EACjD,yBAAyB;EACzB,oCAAoC;EACpC,kDAAkD;EAClD,yDAAyD;AAC3D;;AAEA;;;;EAIE,6CAA6C;EAC7C,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;;;;EAIE,iDAAiD;EACjD,yBAAyB;EACzB,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;;sEAEsE;AACtE;;;EAGE,wBAAwB;EACxB,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;;;;;;EAOE,0BAA0B;EAC1B,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,qDAAqD;EACrD,8BAA8B;EAC9B,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,oCAAoC;EACpC,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;;;;EAIE,0CAA0C;EAC1C,mCAAmC;EACnC,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;;;EAGE,iDAAiD;EACjD,oCAAoC;EACpC,yBAAyB;EACzB,yDAAyD;AAC3D;;AAEA;;;;;;;EAOE,6CAA6C;EAC7C,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;;EAEE,iDAAiD;EACjD,oCAAoC;EACpC,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA;;sEAEsE;AACtE;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,qDAAqD;EACrD,+DAA+D;EAC/D,gDAAgD;EAChD,sCAAsC;EACtC,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;EACjD,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,yDAAyD;EACzD,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;EAC/C,2DAA2D;EAC3D,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;;sEAEsE;AACtE;;EAEE,oEAAoE;AACtE;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;sEAEsE;AACtE;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,+BAA+B;AAC/B;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;sEAEsE;AACtE;EACE,yCAAyC;EACzC,gDAAgD;EAChD,wDAAwD;EACxD,mDAAmD;EACnD,6CAA6C;EAC7C,6CAA6C;EAC7C,wCAAwC;EACxC,6DAA6D;EAC7D,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,mDAAmD;EACnD,+CAA+C;AACjD;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;EAC9C,2DAA2D;EAC3D,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;sEAEsE;AACtE;EACE,wBAAwB;AAC1B;;AAEA;EACE,6CAA6C;EAC7C,mDAAmD;EACnD,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,6CAA6C;EAC7C,0DAA0D;EAC1D,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;sEAEsE;AACtE;EACE,wBAAwB;AAC1B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,+CAA+C;AACjD","sourcesContent":["/* =================================================================\n   KIU RESOURCE MANAGER - MODERN GLASSMORPHIC DESIGN SYSTEM\n   All colors are defined here as CSS Variables so you can customize\n   or replace the color palette anytime in one place!\n   ================================================================= */\n\n:root {\n  /* -------------------------------------------------------------\n     1. PRIMARY & BRAND PALETTE (Easily swappable)\n     ------------------------------------------------------------- */\n  --rm-primary: #4F46E5;                /* Vibrant Indigo */\n  --rm-primary-hover: #4338CA;\n  --rm-primary-light: rgba(79, 70, 229, 0.10);\n  --rm-primary-border: rgba(79, 70, 229, 0.25);\n  --rm-primary-gradient: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);\n  --rm-primary-glow: rgba(79, 70, 229, 0.25);\n\n  --rm-secondary: #06B6D4;              /* Cyan Ocean */\n  --rm-secondary-hover: #0891B2;\n  --rm-secondary-light: rgba(6, 182, 212, 0.10);\n  --rm-secondary-gradient: linear-gradient(135deg, #06B6D4 0%, #3B82F6 100%);\n\n  --rm-accent-purple: #8B5CF6;\n  --rm-accent-gradient: linear-gradient(135deg, #8B5CF6 0%, #EC4899 100%);\n\n  /* -------------------------------------------------------------\n     2. STATUS / SEMANTIC COLORS\n     ------------------------------------------------------------- */\n  --rm-success: #10B981;                /* Emerald */\n  --rm-success-light: rgba(16, 185, 129, 0.12);\n  --rm-success-border: rgba(16, 185, 129, 0.25);\n  --rm-success-gradient: linear-gradient(135deg, #10B981 0%, #059669 100%);\n\n  --rm-warning: #F59E0B;                /* Amber */\n  --rm-warning-light: rgba(245, 158, 11, 0.12);\n  --rm-warning-border: rgba(245, 158, 11, 0.25);\n  --rm-warning-gradient: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n\n  --rm-danger: #EF4444;                 /* Rose Red */\n  --rm-danger-light: rgba(239, 68, 68, 0.12);\n  --rm-danger-border: rgba(239, 68, 68, 0.25);\n  --rm-danger-gradient: linear-gradient(135deg, #EF4444 0%, #DC2626 100%);\n\n  --rm-info: #0284C7;                   /* Sky Blue */\n  --rm-info-light: rgba(2, 132, 199, 0.12);\n  --rm-info-border: rgba(2, 132, 199, 0.25);\n  --rm-info-gradient: linear-gradient(135deg, #0284C7 0%, #0369A1 100%);\n\n  /* -------------------------------------------------------------\n     3. GLASSMORPHISM & SURFACE DESIGN TOKENS\n     ------------------------------------------------------------- */\n  --rm-bg-main: #F4F7FC;                /* Premium soft slate background */\n  --rm-bg-mesh: radial-gradient(at 0% 0%, rgba(79, 70, 229, 0.08) 0px, transparent 50%),\n                 radial-gradient(at 100% 0%, rgba(6, 182, 212, 0.08) 0px, transparent 50%),\n                 radial-gradient(at 50% 100%, rgba(139, 92, 246, 0.06) 0px, transparent 50%),\n                 #F4F7FC;\n  --rm-surface: #FFFFFF;\n\n  --rm-glass-bg: rgba(255, 255, 255, 0.82);\n  --rm-glass-bg-hover: rgba(255, 255, 255, 0.95);\n  --rm-glass-border: rgba(255, 255, 255, 0.7);\n  --rm-glass-border-subtle: rgba(226, 232, 240, 0.85);\n  --rm-glass-blur: blur(16px);\n  --rm-glass-shadow: 0 10px 30px -5px rgba(15, 23, 42, 0.06), 0 4px 8px -2px rgba(15, 23, 42, 0.03);\n  --rm-glass-shadow-hover: 0 20px 35px -5px rgba(79, 70, 229, 0.12), 0 8px 12px -3px rgba(15, 23, 42, 0.05);\n\n  /* -------------------------------------------------------------\n     4. TYPOGRAPHY & TEXT\n     ------------------------------------------------------------- */\n  --rm-text-primary: #0F172A;\n  --rm-text-secondary: #475569;\n  --rm-text-muted: #94A3B8;\n\n  /* -------------------------------------------------------------\n     5. GEOMETRY & TRANSITIONS\n     ------------------------------------------------------------- */\n  --rm-radius-sm: 8px;\n  --rm-radius-md: 14px;\n  --rm-radius-lg: 20px;\n  --rm-radius-xl: 28px;\n  --rm-radius-full: 9999px;\n  --rm-transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* =================================================================\n   BASE & PAGE WRAPPER MODERNIZATION\n   ================================================================= */\n.page-wrapper {\n  background: var(--rm-bg-mesh) !important;\n  min-height: 100vh;\n  transition: var(--rm-transition);\n}\n\n/* =================================================================\n   GLASSMORPHIC CARDS & CONTAINERS\n   ================================================================= */\n.rm-glass-card {\n  background: var(--rm-glass-bg) !important;\n  backdrop-filter: var(--rm-glass-blur) !important;\n  -webkit-backdrop-filter: var(--rm-glass-blur) !important;\n  border: 1px solid var(--rm-glass-border) !important;\n  border-radius: var(--rm-radius-lg) !important;\n  box-shadow: var(--rm-glass-shadow) !important;\n  transition: var(--rm-transition);\n  position: relative;\n  overflow: visible;\n}\n\n.rm-glass-card.rm-clipped {\n  overflow: hidden !important;\n}\n\n.rm-overflow-visible,\n.card.rm-overflow-visible,\n.rm-glass-card.rm-overflow-visible {\n  overflow: visible !important;\n}\n\n.rm-glass-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);\n  pointer-events: none;\n}\n\n.rm-glass-card-interactive:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--rm-glass-shadow-hover) !important;\n  border-color: rgba(79, 70, 229, 0.3) !important;\n}\n\n/* =================================================================\n   HERO WELCOME BANNER\n   ================================================================= */\n.rm-hero-banner {\n  background: linear-gradient(135deg, #1E1B4B 0%, #312E81 50%, #4338CA 100%) !important;\n  border-radius: var(--rm-radius-xl) !important;\n  padding: 28px 32px !important;\n  color: #FFFFFF !important;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 20px 40px -15px rgba(49, 46, 129, 0.45), 0 0 20px rgba(79, 70, 229, 0.2) !important;\n  margin-bottom: 24px !important;\n  border: 1px solid rgba(255, 255, 255, 0.15) !important;\n}\n\n.rm-hero-banner::after {\n  content: \"\";\n  position: absolute;\n  top: -60px;\n  right: -60px;\n  width: 240px;\n  height: 240px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.18) 0%, transparent 70%);\n  pointer-events: none;\n}\n\n.rm-hero-title,\n.rm-hero-banner h1,\n.rm-hero-banner h2,\n.rm-hero-banner h3,\n.rm-hero-banner h4,\n.rm-hero-banner h5 {\n  color: #FFFFFF !important;\n  font-size: 1.75rem !important;\n  font-weight: 700 !important;\n  letter-spacing: -0.02em;\n  margin-bottom: 6px;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);\n}\n\n.rm-hero-subtitle {\n  color: rgba(255, 255, 255, 0.88) !important;\n  font-size: 0.95rem;\n}\n\n.rm-hero-badge {\n  background: rgba(255, 255, 255, 0.18) !important;\n  border: 1px solid rgba(255, 255, 255, 0.3) !important;\n  color: #FFFFFF !important;\n  backdrop-filter: blur(8px);\n  font-weight: 600;\n  letter-spacing: 0.03em;\n}\n\n.rm-hero-date {\n  color: rgba(255, 255, 255, 0.78) !important;\n}\n\n.rm-hero-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n/* =================================================================\n   QUICK ACTION BUTTONS\n   ================================================================= */\n.rm-action-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  border-radius: var(--rm-radius-full);\n  font-weight: 600;\n  font-size: 0.875rem;\n  text-decoration: none !important;\n  transition: var(--rm-transition);\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  background: rgba(255, 255, 255, 0.12);\n  color: #FFFFFF !important;\n  backdrop-filter: blur(8px);\n}\n\n.rm-action-pill:hover {\n  background: #FFFFFF;\n  color: var(--rm-primary) !important;\n  transform: translateY(-2px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);\n}\n\n/* =================================================================\n   TOP KPI STAT SUMMARY CARDS\n   ================================================================= */\n.rm-kpi-card {\n  padding: 22px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: var(--rm-radius-lg);\n  background: var(--rm-glass-bg);\n  backdrop-filter: var(--rm-glass-blur);\n  border: 1px solid var(--rm-glass-border);\n  box-shadow: var(--rm-glass-shadow);\n  transition: var(--rm-transition);\n  position: relative;\n  overflow: hidden;\n}\n\n.rm-kpi-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--rm-glass-shadow-hover);\n}\n\n.rm-kpi-icon-wrap {\n  width: 54px;\n  height: 54px;\n  border-radius: var(--rm-radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  flex-shrink: 0;\n  transition: var(--rm-transition);\n}\n\n.rm-kpi-card:hover .rm-kpi-icon-wrap {\n  transform: scale(1.08) rotate(3deg);\n}\n\n.rm-kpi-label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--rm-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 4px;\n}\n\n.rm-kpi-val {\n  font-size: 1.85rem;\n  font-weight: 800;\n  color: var(--rm-text-primary);\n  line-height: 1.1;\n  margin-bottom: 4px;\n}\n\n.rm-kpi-sub {\n  font-size: 0.775rem;\n  color: var(--rm-text-muted);\n}\n\n/* Sub-card inside widget */\n.rm-sub-glass-item {\n  padding: 14px 16px;\n  border-radius: var(--rm-radius-md);\n  background: rgba(255, 255, 255, 0.65);\n  border: 1px solid rgba(226, 232, 240, 0.7);\n  transition: var(--rm-transition);\n}\n\n.rm-sub-glass-item:hover {\n  background: rgba(255, 255, 255, 0.95);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);\n}\n\n.rm-sub-glass-num {\n  font-size: 1.45rem;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n/* =================================================================\n   MOBILE RESPONSIVENESS (100% Mobile Ready)\n   ================================================================= */\n@media (max-width: 991.98px) {\n  .rm-hero-banner {\n    padding: 20px;\n    border-radius: var(--rm-radius-lg);\n  }\n  \n  .rm-hero-title {\n    font-size: 1.35rem;\n  }\n  \n  .rm-hero-actions {\n    margin-top: 14px;\n    width: 100%;\n  }\n\n  .rm-action-pill {\n    flex: 1 1 calc(50% - 10px);\n    justify-content: center;\n    padding: 8px 12px;\n    font-size: 0.8rem;\n  }\n  \n  .rm-kpi-card {\n    padding: 16px 18px;\n  }\n\n  .rm-kpi-val {\n    font-size: 1.5rem;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .rm-hero-banner {\n    padding: 16px;\n  }\n\n  .rm-action-pill {\n    flex: 1 1 100%;\n  }\n\n  .page-wrapper .content {\n    padding: 12px 8px !important;\n  }\n\n  .rm-glass-card {\n    border-radius: var(--rm-radius-md) !important;\n  }\n\n  .rm-sub-glass-num {\n    font-size: 1.2rem;\n  }\n}\n\n/* =================================================================\n   HEADER & SIDEBAR STYLES\n   ================================================================= */\n.sidebar .sidebar-menu > ul > li > a {\n  border-radius: var(--rm-radius-md) !important;\n  margin: 4px 10px !important;\n  transition: var(--rm-transition) !important;\n  color: var(--rm-text-secondary) !important;\n  font-weight: 500;\n}\n\n.sidebar .sidebar-menu > ul > li > a:hover {\n  background: var(--rm-primary-light) !important;\n  color: var(--rm-primary) !important;\n}\n\n.sidebar .sidebar-menu > ul > li.active > a {\n  background: var(--rm-primary-gradient) !important;\n  color: #FFFFFF !important;\n  box-shadow: 0 6px 16px -2px var(--rm-primary-glow) !important;\n}\n\n/* =================================================================\n   UNIVERSAL BUTTON MODERNIZATION (Across All Pages)\n   ================================================================= */\n.btn {\n  border-radius: 10px !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.01em;\n  padding: 8px 18px !important;\n  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 6px !important;\n  position: relative;\n  overflow: hidden;\n  border: 1px solid transparent !important;\n}\n\n.btn:active {\n  transform: scale(0.97) !important;\n}\n\n/* Primary Button */\n.btn-primary,\n.btn-save,\n.btn-send {\n  background: var(--rm-primary-gradient) !important;\n  border-color: transparent !important;\n  color: #FFFFFF !important;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.28) !important;\n}\n\n.btn-primary:hover,\n.btn-save:hover,\n.btn-send:hover {\n  background: linear-gradient(135deg, #4338CA 0%, #6D28D9 100%) !important;\n  color: #FFFFFF !important;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 18px rgba(79, 70, 229, 0.4) !important;\n}\n\n/* Secondary Button */\n.btn-secondary {\n  background: var(--rm-secondary-gradient) !important;\n  border-color: transparent !important;\n  color: #FFFFFF !important;\n  box-shadow: 0 4px 12px rgba(6, 182, 212, 0.28) !important;\n}\n\n.btn-secondary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 18px rgba(6, 182, 212, 0.4) !important;\n}\n\n/* Success Button */\n.btn-success {\n  background: var(--rm-success-gradient) !important;\n  border-color: transparent !important;\n  color: #FFFFFF !important;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.28) !important;\n}\n\n.btn-success:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 18px rgba(16, 185, 129, 0.4) !important;\n}\n\n/* Danger Button */\n.btn-danger {\n  background: var(--rm-danger-gradient) !important;\n  border-color: transparent !important;\n  color: #FFFFFF !important;\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.28) !important;\n}\n\n.btn-danger:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 18px rgba(239, 68, 68, 0.4) !important;\n}\n\n/* Warning Button */\n.btn-warning {\n  background: var(--rm-warning-gradient) !important;\n  border-color: transparent !important;\n  color: #FFFFFF !important;\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.28) !important;\n}\n\n.btn-warning:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 18px rgba(245, 158, 11, 0.4) !important;\n}\n\n/* Info Button */\n.btn-info {\n  background: var(--rm-info-gradient) !important;\n  border-color: transparent !important;\n  color: #FFFFFF !important;\n  box-shadow: 0 4px 12px rgba(2, 132, 199, 0.28) !important;\n}\n\n/* Outline Buttons */\n.btn-outline-primary {\n  border-color: var(--rm-primary) !important;\n  color: var(--rm-primary) !important;\n  background: rgba(79, 70, 229, 0.05) !important;\n}\n\n.btn-outline-primary:hover {\n  background: var(--rm-primary-gradient) !important;\n  color: #FFFFFF !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.3) !important;\n}\n\n.btn-outline-secondary {\n  border-color: #CBD5E1 !important;\n  color: var(--rm-text-secondary) !important;\n  background: rgba(255, 255, 255, 0.7) !important;\n}\n\n.btn-outline-secondary:hover {\n  background: #F1F5F9 !important;\n  color: var(--rm-text-primary) !important;\n  transform: translateY(-2px);\n}\n\n.btn-reset,\n.btn-cancel {\n  background: #F1F5F9 !important;\n  color: #475569 !important;\n  border: 1px solid #E2E8F0 !important;\n  border-radius: 10px !important;\n  font-weight: 600 !important;\n}\n\n.btn-reset:hover,\n.btn-cancel:hover {\n  background: #E2E8F0 !important;\n  color: #0F172A !important;\n}\n\n/* Action Table Icon Buttons */\n.action-table-data a,\n.table-action-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: var(--rm-transition);\n  background: rgba(241, 245, 249, 0.8);\n  color: var(--rm-text-secondary) !important;\n  margin: 0 3px;\n}\n\n.action-table-data a:hover,\n.table-action-btn:hover {\n  background: var(--rm-primary-light);\n  color: var(--rm-primary) !important;\n  transform: scale(1.1);\n}\n\n/* =================================================================\n   UNIVERSAL TABLE MODERNIZATION (Ant Design & Bootstrap Tables)\n   ================================================================= */\n.card .table,\n.table-responsive,\n.data-table-card,\n.ant-table-wrapper {\n  border-radius: var(--rm-radius-lg);\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Ant Table & General Table Container */\n.ant-table,\n.table {\n  background: transparent !important;\n  color: var(--rm-text-primary) !important;\n  border-collapse: separate !important;\n  border-spacing: 0 !important;\n  width: 100%;\n}\n\n/* Table Header */\n.ant-table-thead > tr > th,\n.table thead th {\n  background: #F8FAFC !important;\n  color: #475569 !important;\n  font-weight: 700 !important;\n  font-size: 0.8rem !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.05em !important;\n  padding: 14px 16px !important;\n  border-bottom: 2px solid #E2E8F0 !important;\n  border-top: none !important;\n  white-space: nowrap;\n}\n\n/* Table Rows & Cells */\n.ant-table-tbody > tr > td,\n.table tbody td {\n  padding: 14px 16px !important;\n  vertical-align: middle !important;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.75) !important;\n  color: #334155 !important;\n  font-size: 0.875rem !important;\n  background: transparent !important;\n  transition: background 0.15s ease !important;\n}\n\n/* Row Hover Highlight */\n.ant-table-tbody > tr:hover > td,\n.table-hover tbody tr:hover td {\n  background: rgba(79, 70, 229, 0.04) !important;\n}\n\n/* Data Table Card Wrapper */\n.data-table-card {\n  background: var(--rm-glass-bg) !important;\n  backdrop-filter: var(--rm-glass-blur) !important;\n  -webkit-backdrop-filter: var(--rm-glass-blur) !important;\n  border: 1px solid var(--rm-glass-border) !important;\n  border-radius: var(--rm-radius-lg) !important;\n  box-shadow: var(--rm-glass-shadow) !important;\n  padding: 16px !important;\n  margin-bottom: 24px !important;\n}\n\n/* Modern Ant Pagination */\n.ant-pagination {\n  margin-top: 20px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: flex-end !important;\n  gap: 6px !important;\n}\n\n.ant-pagination .ant-pagination-item {\n  border-radius: 8px !important;\n  border: 1px solid #E2E8F0 !important;\n  font-weight: 600 !important;\n  background: #FFFFFF !important;\n  transition: var(--rm-transition) !important;\n}\n\n.ant-pagination .ant-pagination-item-active {\n  background: var(--rm-primary-gradient) !important;\n  border-color: transparent !important;\n  box-shadow: 0 4px 10px rgba(79, 70, 229, 0.3) !important;\n}\n\n.ant-pagination .ant-pagination-item-active a {\n  color: #FFFFFF !important;\n}\n\n.ant-pagination .ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination .ant-pagination-next .ant-pagination-item-link {\n  border-radius: 8px !important;\n  border: 1px solid #E2E8F0 !important;\n  background: #FFFFFF !important;\n}\n\n/* =================================================================\n   UNIVERSAL CARDS & CONTAINERS (Across All Pages)\n   ================================================================= */\n.card {\n  background: var(--rm-glass-bg) !important;\n  backdrop-filter: var(--rm-glass-blur) !important;\n  -webkit-backdrop-filter: var(--rm-glass-blur) !important;\n  border: 1px solid var(--rm-glass-border) !important;\n  border-radius: var(--rm-radius-lg) !important;\n  box-shadow: var(--rm-glass-shadow) !important;\n  transition: var(--rm-transition) !important;\n  margin-bottom: 20px !important;\n}\n\n.card:hover {\n  box-shadow: var(--rm-glass-shadow-hover) !important;\n}\n\n.card-header {\n  background: transparent !important;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.7) !important;\n  padding: 18px 22px !important;\n}\n\n.card-body {\n  padding: 20px 22px !important;\n}\n\n/* =================================================================\n   FORM CONTROLS & INPUTS (Sleek Modern Touch)\n   ================================================================= */\n.form-control,\n.form-select {\n  border-radius: 10px !important;\n  border: 1.5px solid #E2E8F0 !important;\n  padding: 10px 14px !important;\n  font-size: 0.9rem !important;\n  background-color: #FFFFFF !important;\n  color: var(--rm-text-primary) !important;\n  transition: var(--rm-transition) !important;\n}\n\n.form-control:focus,\n.form-select:focus {\n  border-color: var(--rm-primary) !important;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.16) !important;\n  background-color: #FFFFFF !important;\n}\n\n/* =================================================================\n   SOFT STATUS BADGES\n   ================================================================= */\n.badge {\n  border-radius: var(--rm-radius-full) !important;\n  padding: 6px 12px !important;\n  font-weight: 600 !important;\n  font-size: 0.775rem !important;\n  letter-spacing: 0.02em !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 4px !important;\n}\n\n.badge-soft-success,\n.badge-success {\n  background: var(--rm-success-light) !important;\n  color: var(--rm-success) !important;\n  border: 1px solid var(--rm-success-border) !important;\n}\n\n.badge-soft-danger,\n.badge-danger {\n  background: var(--rm-danger-light) !important;\n  color: var(--rm-danger) !important;\n  border: 1px solid var(--rm-danger-border) !important;\n}\n\n.badge-soft-warning,\n.badge-warning {\n  background: var(--rm-warning-light) !important;\n  color: #D97706 !important;\n  border: 1px solid var(--rm-warning-border) !important;\n}\n\n.badge-soft-info,\n.badge-info {\n  background: var(--rm-info-light) !important;\n  color: var(--rm-info) !important;\n  border: 1px solid var(--rm-info-border) !important;\n}\n\n.badge-soft-primary,\n.badge-primary {\n  background: var(--rm-primary-light) !important;\n  color: var(--rm-primary) !important;\n  border: 1px solid var(--rm-primary-border) !important;\n}\n\n/* =================================================================\n   MODALS (Glassmorphic Dialogs)\n   ================================================================= */\n.modal-content {\n  border-radius: var(--rm-radius-xl) !important;\n  background: rgba(255, 255, 255, 0.96) !important;\n  backdrop-filter: blur(20px) !important;\n  border: 1px solid var(--rm-glass-border) !important;\n  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.25) !important;\n  overflow: hidden;\n}\n\n.modal-header {\n  border-bottom: 1px solid rgba(226, 232, 240, 0.8) !important;\n  padding: 20px 24px !important;\n}\n\n.modal-footer {\n  border-top: 1px solid rgba(226, 232, 240, 0.8) !important;\n  padding: 16px 24px !important;\n}\n\n/* =================================================================\n   ROOM REGISTER & ARCHITECTURAL BLUEPRINT SUITE\n   ================================================================= */\n.roomreg-shell {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.roomreg-header-card {\n  background: var(--rm-glass-bg);\n  backdrop-filter: var(--rm-glass-blur);\n  border: 1px solid var(--rm-glass-border-subtle);\n  border-radius: var(--rm-radius-lg);\n  padding: 1.25rem 1.5rem;\n  box-shadow: var(--rm-glass-shadow);\n}\n\n.floor-pill-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border-radius: var(--rm-radius-full);\n  font-size: 0.875rem;\n  font-weight: 600;\n  border: 1px solid rgba(203, 213, 225, 0.8);\n  background: rgba(255, 255, 255, 0.9);\n  color: var(--rm-text-secondary);\n  transition: var(--rm-transition);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.floor-pill-btn:hover {\n  background: #ffffff;\n  border-color: var(--rm-primary);\n  color: var(--rm-primary);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.12);\n}\n\n.floor-pill-btn.active {\n  background: var(--rm-primary-gradient);\n  border-color: transparent;\n  color: #ffffff !important;\n  box-shadow: 0 4px 16px rgba(79, 70, 229, 0.35);\n}\n\n.roomreg-workspace {\n  display: grid;\n  grid-template-columns: 1fr 340px;\n  gap: 1.25rem;\n  align-items: start;\n}\n\n@media (max-width: 1100px) {\n  .roomreg-workspace {\n    grid-template-columns: 1fr;\n  }\n}\n\n.blueprint-canvas-container {\n  background: #ffffff;\n  border-radius: var(--rm-radius-lg);\n  border: 1px solid rgba(226, 232, 240, 0.9);\n  box-shadow: var(--rm-glass-shadow);\n  overflow: hidden;\n  position: relative;\n  transition: var(--rm-transition);\n}\n\n.blueprint-header-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1.25rem;\n  background: rgba(248, 250, 252, 0.85);\n  border-bottom: 1px solid rgba(226, 232, 240, 0.9);\n  backdrop-filter: blur(8px);\n}\n\n.room-inspector-card {\n  background: var(--rm-glass-bg);\n  backdrop-filter: var(--rm-glass-blur);\n  border: 1px solid var(--rm-glass-border-subtle);\n  border-radius: var(--rm-radius-lg);\n  box-shadow: var(--rm-glass-shadow);\n  overflow: hidden;\n  position: sticky;\n  top: 1rem;\n}\n\n.room-inspector-header {\n  padding: 1.25rem 1.25rem 0.75rem 1.25rem;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.room-inspector-body {\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  max-height: calc(85vh - 120px);\n  overflow-y: auto;\n}\n\n.asset-chip {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 0.75rem;\n  background: rgba(248, 250, 252, 0.9);\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  border-radius: var(--rm-radius-md);\n  font-size: 0.85rem;\n  font-weight: 500;\n  transition: var(--rm-transition);\n}\n\n.asset-chip:hover {\n  background: #ffffff;\n  border-color: var(--rm-primary-border);\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);\n}\n\n.room-grid-card {\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: var(--rm-glass-blur);\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  border-radius: var(--rm-radius-lg);\n  padding: 1.25rem;\n  transition: var(--rm-transition);\n  box-shadow: var(--rm-glass-shadow);\n  cursor: pointer;\n  position: relative;\n}\n\n.room-grid-card:hover {\n  transform: translateY(-3px);\n  border-color: var(--rm-primary);\n  box-shadow: var(--rm-glass-shadow-hover);\n}\n\n.room-grid-card.selected {\n  border-color: var(--rm-primary);\n  background: rgba(238, 242, 255, 0.85);\n  box-shadow: 0 0 0 2px var(--rm-primary), var(--rm-glass-shadow-hover);\n}\n\n/* =================================================================\n   MODERN EXECUTIVE HEADER / NAVBAR\n   ================================================================= */\n.header {\n  background: #ffffff !important;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.9) !important;\n  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.05) !important;\n  height: 56px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  padding: 0 20px 0 0 !important;\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  z-index: 1030 !important;\n  transform: none !important;\n  -webkit-transform: none !important;\n  backface-visibility: visible !important;\n  -webkit-backface-visibility: visible !important;\n  transition: width 0.3s ease, background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease !important;\n}\n\n.header-left {\n  background: transparent !important;\n  border-right: 1px solid rgba(226, 232, 240, 0.8) !important;\n  height: 56px !important;\n  width: 276px !important;\n  min-width: 276px !important;\n  max-width: 276px !important;\n  float: none !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  padding: 0 16px !important;\n  margin: 0 !important;\n  transition: all 0.3s ease !important;\n  box-sizing: border-box !important;\n}\n\n.header-left .logo img {\n  max-height: 38px !important;\n  width: auto !important;\n  object-fit: contain !important;\n}\n\n.header-left .logo-small img {\n  max-height: 32px !important;\n  width: auto !important;\n  object-fit: contain !important;\n}\n\n/* Mini Sidebar Header Transitions */\n.mini-sidebar .header-left {\n  width: 80px !important;\n  min-width: 80px !important;\n  max-width: 80px !important;\n  padding: 0 8px !important;\n  flex-direction: row !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n}\n\n.mini-sidebar .header-left .logo-small img {\n  max-height: 26px !important;\n  width: auto !important;\n}\n\n.mini-sidebar .header-left #toggle_btn {\n  width: 28px !important;\n  height: 28px !important;\n  font-size: 14px !important;\n  border-radius: 6px !important;\n}\n\n.mini-sidebar.expand-menu .header-left {\n  width: 276px !important;\n  min-width: 276px !important;\n  max-width: 276px !important;\n  padding: 0 16px !important;\n  justify-content: space-between !important;\n}\n\n#toggle_btn {\n  background: rgba(241, 245, 249, 0.9) !important;\n  border-radius: 8px !important;\n  width: 32px !important;\n  height: 32px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: #475569 !important;\n  transition: var(--rm-transition) !important;\n  text-decoration: none !important;\n  flex-shrink: 0 !important;\n}\n\n#toggle_btn:hover {\n  background: var(--rm-primary) !important;\n  color: #ffffff !important;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25) !important;\n}\n\n/* Header Search Bar */\n.header-search-wrap {\n  flex: 1 !important;\n  max-width: 440px !important;\n  margin: 0 20px !important;\n  position: relative !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.header-search-wrap .search-icon {\n  position: absolute !important;\n  left: 14px !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n  color: #94a3b8 !important;\n  font-size: 15px !important;\n  pointer-events: none !important;\n  z-index: 2 !important;\n}\n\n.header-search-wrap input {\n  width: 100% !important;\n  height: 38px !important;\n  padding: 0 44px 0 38px !important;\n  border-radius: 9999px !important;\n  background: rgba(241, 245, 249, 0.85) !important;\n  border: 1px solid rgba(203, 213, 225, 0.8) !important;\n  color: #1e293b !important;\n  font-size: 0.85rem !important;\n  box-shadow: none !important;\n  transition: all 0.25s ease !important;\n}\n\n.header-search-wrap input:focus {\n  background: #ffffff !important;\n  border-color: var(--rm-primary) !important;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15) !important;\n  outline: none !important;\n}\n\n.header-search-wrap .search-shortcut {\n  position: absolute !important;\n  right: 12px !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n  font-size: 11px !important;\n  padding: 2px 7px !important;\n  border-radius: 6px !important;\n  background: rgba(203, 213, 225, 0.45) !important;\n  color: #64748b !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.02em !important;\n  pointer-events: none !important;\n}\n\n/* Header Right Controls */\n.header-right-controls {\n  display: flex !important;\n  align-items: center !important;\n  gap: 14px !important;\n  margin-left: auto !important;\n  flex-shrink: 0 !important;\n}\n\n/* Day/Night Mode Switcher */\n.dark-mode-toggle {\n  background: rgba(241, 245, 249, 0.95) !important;\n  border: 1px solid rgba(203, 213, 225, 0.9) !important;\n  border-radius: 9999px !important;\n  padding: 3px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  position: relative !important;\n  cursor: pointer !important;\n  height: 34px !important;\n  width: 68px !important;\n  box-sizing: border-box !important;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n  user-select: none !important;\n}\n\n.dark-mode-toggle .toggle-thumb {\n  position: absolute !important;\n  top: 3px !important;\n  left: 3px !important;\n  width: 26px !important;\n  height: 26px !important;\n  border-radius: 50% !important;\n  background: #ffffff !important;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2) !important;\n  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), background 0.25s ease !important;\n  z-index: 1 !important;\n}\n\n.dark-mode-toggle.is-dark .toggle-thumb {\n  transform: translateX(34px) !important;\n  background: var(--rm-primary) !important;\n  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.5) !important;\n}\n\n.dark-mode-toggle i {\n  width: 28px !important;\n  height: 26px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  font-size: 13px !important;\n  position: relative !important;\n  z-index: 2 !important;\n  color: #64748b !important;\n  transition: all 0.2s ease !important;\n}\n\n.dark-mode-toggle.is-light .light-mode {\n  color: #f59e0b !important;\n  font-weight: bold !important;\n}\n\n.dark-mode-toggle.is-dark .dark-mode {\n  color: #ffffff !important;\n  font-weight: bold !important;\n}\n\n[data-theme=\"dark\"] .dark-mode-toggle {\n  background: rgba(30, 41, 59, 0.9) !important;\n  border-color: rgba(51, 65, 85, 0.95) !important;\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.4) !important;\n}\n\n/* Executive User Profile Chip */\n.header-user-chip {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  padding: 5px 12px 5px 14px !important;\n  border-radius: 9999px !important;\n  background: rgba(241, 245, 249, 0.75) !important;\n  border: 1px solid rgba(226, 232, 240, 0.9) !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n  text-decoration: none !important;\n}\n\n.header-user-chip:hover {\n  background: rgba(241, 245, 249, 1) !important;\n  border-color: rgba(203, 213, 225, 1) !important;\n}\n\n.header-user-chip .user-info-text {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: flex-start !important;\n  line-height: 1.15 !important;\n}\n\n.header-user-chip .user-name {\n  font-size: 0.82rem !important;\n  font-weight: 700 !important;\n  color: #1e293b !important;\n}\n\n.header-user-chip .user-role-badge {\n  font-size: 0.65rem !important;\n  font-weight: 700 !important;\n  color: var(--rm-primary) !important;\n  background: rgba(79, 70, 229, 0.1) !important;\n  padding: 1px 6px !important;\n  border-radius: 4px !important;\n  letter-spacing: 0.03em !important;\n}\n\n.header-user-chip .avatar-wrapper {\n  position: relative !important;\n  width: 34px !important;\n  height: 34px !important;\n  flex-shrink: 0 !important;\n}\n\n.header-user-chip .avatar-img {\n  width: 34px !important;\n  height: 34px !important;\n  border-radius: 50% !important;\n  object-fit: cover !important;\n  border: 1.5px solid #ffffff !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;\n}\n\n.header-user-chip .online-status-dot {\n  position: absolute !important;\n  bottom: 0 !important;\n  right: 0 !important;\n  width: 9px !important;\n  height: 9px !important;\n  border-radius: 50% !important;\n  background: #10B981 !important;\n  border: 1.5px solid #ffffff !important;\n  box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.3) !important;\n}\n\n.header-user-chip .chevron-icon {\n  font-size: 12px !important;\n  color: #94a3b8 !important;\n  transition: transform 0.2s ease !important;\n}\n\n/* Dropdown Menu Positioning & Styling */\n.header .dropdown-menu {\n  top: 50px !important;\n  right: 0 !important;\n  left: auto !important;\n  border-radius: 14px !important;\n  box-shadow: 0 12px 36px -4px rgba(15, 23, 42, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05) !important;\n  border: 1px solid rgba(226, 232, 240, 0.9) !important;\n  background: rgba(255, 255, 255, 0.98) !important;\n  backdrop-filter: blur(16px) !important;\n  padding: 8px !important;\n  min-width: 230px !important;\n  z-index: 1050 !important;\n}\n\n/* Dark Theme Overrides for Header */\n[data-theme=\"dark\"] .header {\n  background: rgba(15, 23, 42, 0.95) !important;\n  border-bottom-color: rgba(51, 65, 85, 0.8) !important;\n}\n\n[data-theme=\"dark\"] .header-left {\n  border-right-color: rgba(51, 65, 85, 0.8) !important;\n}\n\n[data-theme=\"dark\"] .header-search-wrap input {\n  background: rgba(30, 41, 59, 0.8) !important;\n  border-color: rgba(51, 65, 85, 0.9) !important;\n  color: #f1f5f9 !important;\n}\n\n[data-theme=\"dark\"] .header-user-chip {\n  background: rgba(30, 41, 59, 0.7) !important;\n  border-color: rgba(51, 65, 85, 0.8) !important;\n}\n\n[data-theme=\"dark\"] .header-user-chip .user-name {\n  color: #f1f5f9 !important;\n}\n\n[data-theme=\"dark\"] .header .dropdown-menu {\n  background: rgba(30, 41, 59, 0.98) !important;\n  border-color: rgba(51, 65, 85, 0.9) !important;\n}\n\n/* =================================================================\n   MODERN EXECUTIVE SIDEBAR\n   ================================================================= */\n.sidebar {\n  background: #ffffff !important;\n  border-right: 1px solid rgba(226, 232, 240, 0.9) !important;\n  box-shadow: 2px 0 14px -2px rgba(15, 23, 42, 0.04) !important;\n  position: fixed !important;\n  top: 56px !important;\n  bottom: 0 !important;\n  left: 0 !important;\n  width: 276px !important;\n  height: calc(100vh - 56px) !important;\n  z-index: 1025 !important;\n  overflow: hidden !important;\n  overscroll-behavior: contain !important;\n  overscroll-behavior-y: contain !important;\n  transform: none !important;\n  -webkit-transform: none !important;\n  backface-visibility: visible !important;\n  -webkit-backface-visibility: visible !important;\n  transition: width 0.3s ease, background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease !important;\n}\n\n.sidebar .sidebar-inner,\n.sidebar [style*=\"overflow\"] {\n  overscroll-behavior: contain !important;\n  overscroll-behavior-y: contain !important;\n}\n\n.sidebar-profile-card {\n  background: linear-gradient(135deg, rgba(79, 70, 229, 0.06) 0%, rgba(6, 182, 212, 0.04) 100%) !important;\n  border: 1px solid rgba(79, 70, 229, 0.15) !important;\n  border-radius: 12px !important;\n  padding: 10px 12px !important;\n  margin: 10px 6px 14px 6px !important;\n  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.04) !important;\n  transition: var(--rm-transition);\n}\n\n.sidebar-menu {\n  padding: 8px 10px !important;\n}\n\n.sidebar-menu .submenu-hdr {\n  font-size: 0.72rem !important;\n  font-weight: 700 !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.08em !important;\n  color: #94a3b8 !important;\n  padding: 12px 10px 6px !important;\n  margin-bottom: 2px !important;\n}\n\n.sidebar-menu ul li a {\n  border-radius: 10px !important;\n  padding: 10px 14px !important;\n  font-size: 0.88rem !important;\n  font-weight: 500 !important;\n  color: #475569 !important;\n  display: flex !important;\n  align-items: center !important;\n  transition: var(--rm-transition) !important;\n  margin-bottom: 2px !important;\n}\n\n.sidebar-menu ul li a i {\n  font-size: 1.15rem !important;\n  margin-right: 12px !important;\n  color: #64748b !important;\n  transition: var(--rm-transition) !important;\n  background: transparent !important;\n}\n\n.sidebar-menu ul li a:hover {\n  background: rgba(79, 70, 229, 0.08) !important;\n  color: var(--rm-primary) !important;\n  transform: translateX(3px) !important;\n}\n\n.sidebar-menu ul li a:hover i {\n  color: var(--rm-primary) !important;\n}\n\n/* FIX: OVERRIDE RED TEXT ON ACTIVE ITEMS */\n.sidebar .sidebar-menu ul li a.active,\n.sidebar .sidebar-menu ul li a.active span,\n.sidebar .sidebar-menu ul li a.active i,\n.sidebar .sidebar-menu ul li.submenu > a.active,\n.sidebar .sidebar-menu ul li.submenu > a.active span,\n.sidebar .sidebar-menu ul li.submenu > a.active i,\n.sidebar .sidebar-menu > ul li.submenu > a.active,\n.sidebar .sidebar-menu > ul li.submenu > a.active span,\n.sidebar .sidebar-menu > ul li.submenu > a.active i,\n.sidebar .sidebar-menu > ul li.submenu > a.subdrop,\n.sidebar .sidebar-menu > ul li.submenu > a.subdrop span,\n.sidebar .sidebar-menu > ul li.submenu > a.subdrop i {\n  color: #ffffff !important;\n}\n\n.sidebar .sidebar-menu ul li a.active,\n.sidebar .sidebar-menu ul li.submenu > a.subdrop,\n.sidebar .sidebar-menu > ul li.submenu > a.subdrop {\n  background: var(--rm-primary-gradient) !important;\n  box-shadow: 0 4px 16px rgba(79, 70, 229, 0.28) !important;\n}\n\n.sidebar .sidebar-menu ul li a.active i,\n.sidebar .sidebar-menu ul li.submenu > a.subdrop i,\n.sidebar .sidebar-menu > ul li.submenu > a.subdrop i {\n  background: transparent !important;\n  color: #ffffff !important;\n}\n\n/* FIX: REMOVE BROKEN PSEUDO-ELEMENT VERTICAL PIPES & DOTS IN SUBMENU */\n.sidebar .sidebar-menu > ul li .submenu > ul li a:before,\n.sidebar .sidebar-menu > ul li .submenu > ul li a:after,\n.sidebar .sidebar-menu ul li.submenu ul li a:before,\n.sidebar .sidebar-menu ul li.submenu ul li a:after,\n.sidebar .sidebar-menu ul li.submenu > ul li a:before,\n.sidebar .sidebar-menu ul li.submenu > ul li a:after {\n  display: none !important;\n  content: none !important;\n  width: 0 !important;\n  height: 0 !important;\n}\n\n/* CLEAN MODERN SUBMENU TREE */\n.sidebar-menu ul li.submenu ul,\n.sidebar .sidebar-menu > ul li .submenu > ul {\n  padding: 4px 0 6px 0 !important;\n  margin: 2px 0 4px 8px !important;\n  border-left: 2px solid rgba(226, 232, 240, 0.85) !important;\n}\n\n.sidebar-menu ul li.submenu ul li a,\n.sidebar .sidebar-menu > ul li .submenu > ul li a {\n  padding: 7px 12px 7px 18px !important;\n  margin: 2px 6px !important;\n  font-size: 0.84rem !important;\n  color: #64748b !important;\n  border-radius: 8px !important;\n  display: flex !important;\n  align-items: center !important;\n  transition: all 0.2s ease !important;\n}\n\n.sidebar-menu ul li.submenu ul li a:hover,\n.sidebar .sidebar-menu > ul li .submenu > ul li a:hover {\n  color: var(--rm-primary) !important;\n  background: rgba(79, 70, 229, 0.08) !important;\n  padding-left: 22px !important;\n}\n\n.sidebar-menu ul li.submenu ul li a.active,\n.sidebar .sidebar-menu > ul li .submenu > ul li a.active {\n  background: rgba(79, 70, 229, 0.12) !important;\n  color: var(--rm-primary) !important;\n  font-weight: 600 !important;\n  box-shadow: none !important;\n}\n\n.mini-sidebar .sidebar {\n  width: 80px !important;\n}\n\n.page-wrapper {\n  min-height: calc(100vh - 56px) !important;\n}\n\n.page-wrapper .content {\n  padding: 24px 28px !important;\n}\n\n/* =================================================================\n   COMPREHENSIVE DARK THEME SYSTEM\n   ================================================================= */\n[data-theme=\"dark\"],\n[data-theme=\"dark\"] body {\n  --rm-bg-main: #0B0F19;\n  --rm-bg-mesh: radial-gradient(at 0% 0%, rgba(79, 70, 229, 0.15) 0px, transparent 50%),\n                radial-gradient(at 100% 0%, rgba(6, 182, 212, 0.12) 0px, transparent 50%),\n                radial-gradient(at 50% 100%, rgba(139, 92, 246, 0.12) 0px, transparent 50%),\n                #0B0F19;\n  --rm-surface: #111827;\n  --rm-surface-hover: #1F2937;\n  --rm-glass-bg: rgba(17, 24, 39, 0.88);\n  --rm-glass-bg-hover: rgba(31, 41, 55, 0.95);\n  --rm-glass-border: rgba(55, 65, 81, 0.75);\n  --rm-glass-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.5), 0 4px 12px -2px rgba(0, 0, 0, 0.4);\n  --rm-glass-shadow-hover: 0 20px 40px -12px rgba(0, 0, 0, 0.65), 0 8px 16px -4px rgba(0, 0, 0, 0.5);\n\n  --rm-text-primary: #F8FAFC;\n  --rm-text-secondary: #94A3B8;\n  --rm-text-muted: #64748B;\n  --rm-border: rgba(55, 65, 81, 0.8);\n  --rm-border-light: rgba(55, 65, 81, 0.5);\n\n  background: #0B0F19 !important;\n  color: #F8FAFC !important;\n}\n\n/* Page Wrapper and Main Area */\n[data-theme=\"dark\"] .main-wrapper,\n[data-theme=\"dark\"] .page-wrapper,\n[data-theme=\"dark\"] .content {\n  background: var(--rm-bg-mesh) !important;\n  color: #F8FAFC !important;\n}\n\n/* Header & Sidebar in Dark Mode */\n[data-theme=\"dark\"] .header {\n  background: rgba(15, 23, 42, 0.95) !important;\n  border-bottom: 1px solid rgba(51, 65, 85, 0.8) !important;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;\n}\n\n[data-theme=\"dark\"] .header-left {\n  background: rgba(15, 23, 42, 0.98) !important;\n  border-right: 1px solid rgba(51, 65, 85, 0.8) !important;\n}\n\n[data-theme=\"dark\"] .header-search-wrap input {\n  background: rgba(30, 41, 59, 0.85) !important;\n  border-color: rgba(51, 65, 85, 0.9) !important;\n  color: #F8FAFC !important;\n}\n\n[data-theme=\"dark\"] .header-user-chip {\n  background: rgba(30, 41, 59, 0.75) !important;\n  border-color: rgba(51, 65, 85, 0.8) !important;\n}\n\n[data-theme=\"dark\"] .header-user-chip .user-name {\n  color: #F8FAFC !important;\n}\n\n[data-theme=\"dark\"] .sidebar {\n  background: rgba(15, 23, 42, 0.96) !important;\n  border-right: 1px solid rgba(51, 65, 85, 0.8) !important;\n}\n\n[data-theme=\"dark\"] .sidebar .sidebar-profile-card {\n  background: rgba(30, 41, 59, 0.75) !important;\n  border-color: rgba(51, 65, 85, 0.8) !important;\n}\n\n[data-theme=\"dark\"] .sidebar .sidebar-profile-card h5 {\n  color: #F8FAFC !important;\n}\n\n[data-theme=\"dark\"] .sidebar .sidebar-menu > ul > li > a {\n  color: #94A3B8 !important;\n}\n\n[data-theme=\"dark\"] .sidebar .sidebar-menu > ul > li > a:hover {\n  color: #FFFFFF !important;\n  background: rgba(79, 70, 229, 0.2) !important;\n}\n\n[data-theme=\"dark\"] .sidebar .sidebar-menu > ul > li > a.active {\n  color: #FFFFFF !important;\n  background: var(--rm-primary-gradient) !important;\n}\n\n[data-theme=\"dark\"] .sidebar-menu .submenu-hdr {\n  color: #64748B !important;\n}\n\n[data-theme=\"dark\"] .sidebar-menu ul li.submenu ul,\n[data-theme=\"dark\"] .sidebar .sidebar-menu > ul li .submenu > ul {\n  border-left-color: rgba(51, 65, 85, 0.8) !important;\n}\n\n[data-theme=\"dark\"] .sidebar-menu ul li.submenu ul li a,\n[data-theme=\"dark\"] .sidebar .sidebar-menu > ul li .submenu > ul li a {\n  color: #94A3B8 !important;\n}\n\n[data-theme=\"dark\"] .sidebar-menu ul li.submenu ul li a:hover,\n[data-theme=\"dark\"] .sidebar .sidebar-menu > ul li .submenu > ul li a:hover {\n  color: #818CF8 !important;\n  background: rgba(79, 70, 229, 0.15) !important;\n}\n\n[data-theme=\"dark\"] .sidebar-menu ul li.submenu ul li a.active,\n[data-theme=\"dark\"] .sidebar .sidebar-menu > ul li .submenu > ul li a.active {\n  color: #A5B4FC !important;\n  background: rgba(79, 70, 229, 0.25) !important;\n}\n\n/* Cards & Surfaces in Dark Mode */\n[data-theme=\"dark\"] .card,\n[data-theme=\"dark\"] .rm-glass-card,\n[data-theme=\"dark\"] .rm-kpi-card {\n  background: rgba(17, 24, 39, 0.88) !important;\n  border-color: rgba(55, 65, 81, 0.75) !important;\n  color: #F8FAFC !important;\n  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.5) !important;\n}\n\n[data-theme=\"dark\"] .card-header,\n[data-theme=\"dark\"] .card-footer {\n  background: rgba(15, 23, 42, 0.6) !important;\n  border-color: rgba(55, 65, 81, 0.75) !important;\n  color: #F8FAFC !important;\n}\n\n/* Tables in Dark Mode */\n[data-theme=\"dark\"] .table {\n  color: #CBD5E1 !important;\n  border-color: rgba(55, 65, 81, 0.6) !important;\n}\n\n[data-theme=\"dark\"] .table thead th {\n  background: rgba(30, 41, 59, 0.9) !important;\n  color: #F1F5F9 !important;\n  border-color: rgba(55, 65, 81, 0.8) !important;\n}\n\n[data-theme=\"dark\"] .table tbody td,\n[data-theme=\"dark\"] .table tbody tr {\n  background: transparent !important;\n  border-color: rgba(55, 65, 81, 0.5) !important;\n  color: #CBD5E1 !important;\n}\n\n[data-theme=\"dark\"] .table-striped > tbody > tr:nth-of-type(odd) > * {\n  background-color: rgba(30, 41, 59, 0.45) !important;\n  color: #CBD5E1 !important;\n}\n\n[data-theme=\"dark\"] .table-hover > tbody > tr:hover > * {\n  background-color: rgba(79, 70, 229, 0.12) !important;\n}\n\n/* Inputs & Form Controls in Dark Mode */\n[data-theme=\"dark\"] .form-control,\n[data-theme=\"dark\"] .form-select,\n[data-theme=\"dark\"] input,\n[data-theme=\"dark\"] select {\n  background-color: rgba(30, 41, 59, 0.85) !important;\n  border-color: rgba(71, 85, 105, 0.8) !important;\n  color: #F8FAFC !important;\n}\n\n[data-theme=\"dark\"] .form-control:focus,\n[data-theme=\"dark\"] .form-select:focus {\n  background-color: rgba(30, 41, 59, 1) !important;\n  border-color: var(--rm-primary) !important;\n  color: #FFFFFF !important;\n}\n\n[data-theme=\"dark\"] .form-control::placeholder {\n  color: #64748B !important;\n}\n\n/* Text & Headings in Dark Mode */\n[data-theme=\"dark\"] h1, [data-theme=\"dark\"] h2, [data-theme=\"dark\"] h3,\n[data-theme=\"dark\"] h4, [data-theme=\"dark\"] h5, [data-theme=\"dark\"] h6,\n[data-theme=\"dark\"] .text-dark {\n  color: #F8FAFC !important;\n}\n\n[data-theme=\"dark\"] .text-muted {\n  color: #94A3B8 !important;\n}\n\n[data-theme=\"dark\"] .bg-white {\n  background-color: rgba(17, 24, 39, 0.95) !important;\n}\n\n[data-theme=\"dark\"] .bg-light {\n  background-color: rgba(30, 41, 59, 0.8) !important;\n}\n\n[data-theme=\"dark\"] .border-bottom,\n[data-theme=\"dark\"] .border-top,\n[data-theme=\"dark\"] .border-start,\n[data-theme=\"dark\"] .border-end,\n[data-theme=\"dark\"] .border {\n  border-color: rgba(55, 65, 81, 0.7) !important;\n}\n\n/* Modals & Popups in Dark Mode */\n[data-theme=\"dark\"] .modal-content {\n  background-color: #111827 !important;\n  color: #F8FAFC !important;\n  border: 1px solid rgba(55, 65, 81, 0.8) !important;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.7) !important;\n}\n\n[data-theme=\"dark\"] .modal-header,\n[data-theme=\"dark\"] .modal-footer {\n  border-color: rgba(55, 65, 81, 0.8) !important;\n}\n\n/* Dropdowns in Dark Mode */\n[data-theme=\"dark\"] .dropdown-menu {\n  background-color: rgba(17, 24, 39, 0.95) !important;\n  backdrop-filter: blur(18px) !important;\n  -webkit-backdrop-filter: blur(18px) !important;\n  border-color: rgba(55, 65, 81, 0.8) !important;\n  color: #F8FAFC !important;\n  box-shadow: 0 16px 40px -8px rgba(0, 0, 0, 0.6) !important;\n}\n\n[data-theme=\"dark\"] .dropdown-item {\n  color: #CBD5E1 !important;\n}\n\n[data-theme=\"dark\"] .dropdown-item:hover {\n  background-color: rgba(79, 70, 229, 0.2) !important;\n  color: #FFFFFF !important;\n}\n\n/* =================================================================\n   GLOBAL GLASSMORPHIC DROPDOWN & SELECT SYSTEM\n   ================================================================= */\n.dropdown-menu,\n.select__menu,\n.ant-select-dropdown,\n.p-dropdown-panel {\n  background: rgba(255, 255, 255, 0.92) !important;\n  backdrop-filter: blur(18px) !important;\n  -webkit-backdrop-filter: blur(18px) !important;\n  border: 1px solid rgba(226, 232, 240, 0.9) !important;\n  border-radius: 14px !important;\n  box-shadow: 0 16px 36px -6px rgba(15, 23, 42, 0.14), 0 0 0 1px rgba(255, 255, 255, 0.7) inset !important;\n  padding: 6px !important;\n  z-index: 1060 !important;\n}\n\n.dropdown-item,\n.p-dropdown-item {\n  padding: 8px 14px !important;\n  border-radius: 8px !important;\n  font-size: 0.86rem !important;\n  font-weight: 500 !important;\n  color: #1e293b !important;\n  transition: all 0.15s ease !important;\n}\n\n.dropdown-item:hover,\n.dropdown-item:focus,\n.p-dropdown-item:hover {\n  background: rgba(79, 70, 229, 0.08) !important;\n  color: var(--rm-primary) !important;\n  transform: translateX(2px) !important;\n}\n\n/* =================================================================\n   GLASSMORPHISM DROPDOWN SYSTEM (Universal Glass Effect for All Dropdowns)\n   ================================================================= */\n\n/* 1. GlassSelect Custom Component */\n.rm-glass-select-container {\n  width: 100%;\n  position: relative;\n  display: block;\n}\n\n.rm-glass-select-container.open {\n  z-index: 1060 !important;\n}\n\n.input-group:has(.rm-glass-select-container) {\n  overflow: visible !important;\n}\n\n.rm-glass-select-trigger {\n  background: rgba(255, 255, 255, 0.78) !important;\n  backdrop-filter: blur(14px) saturate(180%) !important;\n  -webkit-backdrop-filter: blur(14px) saturate(180%) !important;\n  border: 1px solid rgba(203, 213, 225, 0.75) !important;\n  color: #1e293b !important;\n  font-size: 0.88rem !important;\n  font-weight: 500 !important;\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04), 0 0 0 1px rgba(255, 255, 255, 0.6) inset !important;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.rm-glass-select-trigger:hover:not(:disabled) {\n  border-color: rgba(99, 102, 241, 0.65) !important;\n  background: rgba(255, 255, 255, 0.92) !important;\n  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.12), 0 0 0 1px rgba(255, 255, 255, 0.9) inset !important;\n}\n\n.rm-glass-select-trigger.active {\n  border-color: var(--rm-primary) !important;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.18), 0 4px 12px rgba(79, 70, 229, 0.1) !important;\n  background: rgba(255, 255, 255, 0.98) !important;\n}\n\n.rm-glass-select-trigger.disabled {\n  background: rgba(241, 245, 249, 0.6) !important;\n  border-color: rgba(226, 232, 240, 0.7) !important;\n  color: #94a3b8 !important;\n  cursor: not-allowed !important;\n}\n\n.rm-glass-select-trigger .rm-select-placeholder {\n  color: #94a3b8 !important;\n  font-weight: 400 !important;\n}\n\n.rm-glass-select-trigger .rm-select-value {\n  color: #1e293b !important;\n  font-weight: 600 !important;\n}\n\n.rm-glass-select-trigger .rm-select-chevron {\n  font-size: 13px !important;\n  color: #64748b !important;\n  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.rm-glass-select-trigger .rm-select-chevron.rotate {\n  transform: rotate(180deg) !important;\n}\n\n.rm-glass-select-trigger .rm-select-clear-btn {\n  font-size: 11px !important;\n  color: #94a3b8 !important;\n  padding: 2px 4px !important;\n  border-radius: 4px !important;\n  cursor: pointer !important;\n  transition: all 0.15s ease !important;\n}\n\n.rm-glass-select-trigger .rm-select-clear-btn:hover {\n  background: rgba(239, 68, 68, 0.12) !important;\n  color: #ef4444 !important;\n}\n\n/* Glassmorphic Dropdown Menu Popup (Custom + Bootstrap + React-Select + System Dropdowns) */\n.rm-glass-select-menu,\n.dropdown-menu,\n.select__menu,\n.react-select__menu,\n[class$=\"__menu\"],\n[class*=\"-menu\"] {\n  background: rgba(255, 255, 255, 0.84) !important;\n  backdrop-filter: blur(18px) saturate(190%) !important;\n  -webkit-backdrop-filter: blur(18px) saturate(190%) !important;\n  border: 1px solid rgba(255, 255, 255, 0.65) !important;\n  border-radius: 14px !important;\n  box-shadow: 0 16px 38px -6px rgba(15, 23, 42, 0.18), 0 0 0 1px rgba(255, 255, 255, 0.8) inset !important;\n  overflow: hidden !important;\n  z-index: 1070 !important;\n}\n\n.rm-glass-select-menu {\n  position: absolute !important;\n  top: calc(100% + 6px) !important;\n  left: 0 !important;\n  right: 0 !important;\n  min-width: 100% !important;\n  animation: rmSelectFadeDown 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards !important;\n}\n\n.rm-glass-select-menu.placement-top {\n  top: auto !important;\n  bottom: calc(100% + 6px) !important;\n  animation: rmSelectFadeUp 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards !important;\n}\n\n@keyframes rmSelectFadeDown {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes rmSelectFadeUp {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.gate-pass-modal-dialog {\n  max-width: 920px !important;\n}\n\n.gate-pass-modal-dialog .modal-content,\n.gate-pass-modal-dialog .modal-body {\n  overflow: visible !important;\n}\n\n.rm-glass-select-menu .rm-select-options-list,\n.react-select__menu-list,\n[class$=\"__menu-list\"] {\n  max-height: 280px !important;\n  overflow-y: auto !important;\n  padding: 6px !important;\n}\n\n.rm-glass-select-menu .rm-select-options-list::-webkit-scrollbar,\n.react-select__menu-list::-webkit-scrollbar,\n[class$=\"__menu-list\"]::-webkit-scrollbar {\n  width: 5px !important;\n}\n\n.rm-glass-select-menu .rm-select-options-list::-webkit-scrollbar-thumb,\n.react-select__menu-list::-webkit-scrollbar-thumb,\n[class$=\"__menu-list\"]::-webkit-scrollbar-thumb {\n  background: rgba(203, 213, 225, 0.85) !important;\n  border-radius: 10px !important;\n}\n\n/* Glass Select Items / Options */\n.rm-glass-select-item,\n.dropdown-menu .dropdown-item,\n.select__option,\n.react-select__option,\n[class$=\"__option\"],\n[class*=\"-option\"] {\n  padding: 9px 13px !important;\n  border-radius: 8px !important;\n  margin: 2px 4px !important;\n  cursor: pointer !important;\n  font-size: 0.86rem !important;\n  color: #334155 !important;\n  font-weight: 500 !important;\n  transition: all 0.18s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.rm-glass-select-item:hover:not(.disabled),\n.dropdown-menu .dropdown-item:hover,\n.select__option:hover,\n.react-select__option:hover,\n.react-select__option--is-focused,\n[class$=\"__option--is-focused\"] {\n  background: rgba(79, 70, 229, 0.09) !important;\n  color: var(--rm-primary, #4F46E5) !important;\n  transform: translateX(3px) !important;\n}\n\n.rm-glass-select-item.selected,\n.dropdown-menu .dropdown-item.active,\n.select__option--is-selected,\n.react-select__option--is-selected,\n[class$=\"__option--is-selected\"] {\n  background: linear-gradient(135deg, rgba(79, 70, 229, 0.95), rgba(99, 102, 241, 0.9)) !important;\n  color: #ffffff !important;\n  font-weight: 600 !important;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.28) !important;\n}\n\n.rm-glass-select-item.disabled,\n.dropdown-menu .dropdown-item.disabled,\n.react-select__option--is-disabled {\n  opacity: 0.5 !important;\n  cursor: not-allowed !important;\n}\n\n/* Glass Controls / Triggers (React-Select & Form-Select) */\n.react-select__control,\n.select__control,\n[class$=\"__control\"] {\n  background: rgba(255, 255, 255, 0.78) !important;\n  backdrop-filter: blur(14px) !important;\n  -webkit-backdrop-filter: blur(14px) !important;\n  border: 1.5px solid rgba(226, 232, 240, 0.85) !important;\n  border-radius: 10px !important;\n  min-height: 42px !important;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02) !important;\n  transition: all 0.2s ease !important;\n}\n\n.react-select__control:hover,\n.select__control:hover,\n[class$=\"__control\"]:hover {\n  border-color: rgba(79, 70, 229, 0.45) !important;\n}\n\n.react-select__control--is-focused,\n.select__control--is-focused,\n[class$=\"__control--is-focused\"] {\n  border-color: #4F46E5 !important;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.16) !important;\n}\n\n.react-select__single-value,\n[class$=\"__single-value\"] {\n  color: #1e293b !important;\n  font-weight: 500 !important;\n}\n\n/* Native select controls fallback glass styling */\n.form-select,\nselect.form-control {\n  background-color: rgba(255, 255, 255, 0.8) !important;\n  backdrop-filter: blur(14px) !important;\n  -webkit-backdrop-filter: blur(14px) !important;\n  border: 1.5px solid rgba(226, 232, 240, 0.85) !important;\n  border-radius: 10px !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03) !important;\n  transition: all 0.2s ease !important;\n}\n\n.form-select:focus,\nselect.form-control:focus {\n  border-color: #4F46E5 !important;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.16) !important;\n}\n\n/* Dark Mode Overrides for All Glass Dropdowns */\n[data-theme=\"dark\"] .rm-glass-select-trigger,\n[data-theme=\"dark\"] .react-select__control,\n[data-theme=\"dark\"] .form-select,\n[data-theme=\"dark\"] select.form-control {\n  background: rgba(30, 41, 59, 0.82) !important;\n  backdrop-filter: blur(14px) !important;\n  -webkit-backdrop-filter: blur(14px) !important;\n  border-color: rgba(71, 85, 105, 0.75) !important;\n  color: #F8FAFC !important;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.06) inset !important;\n}\n\n[data-theme=\"dark\"] .rm-glass-select-trigger:hover:not(:disabled),\n[data-theme=\"dark\"] .react-select__control:hover {\n  background: rgba(30, 41, 59, 0.95) !important;\n  border-color: var(--rm-primary) !important;\n}\n\n[data-theme=\"dark\"] .rm-glass-select-trigger.active,\n[data-theme=\"dark\"] .react-select__control--is-focused {\n  border-color: var(--rm-primary) !important;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.3) !important;\n}\n\n[data-theme=\"dark\"] .rm-glass-select-trigger .rm-select-value,\n[data-theme=\"dark\"] .react-select__single-value {\n  color: #F8FAFC !important;\n}\n\n[data-theme=\"dark\"] .rm-glass-select-menu,\n[data-theme=\"dark\"] .dropdown-menu,\n[data-theme=\"dark\"] .select__menu,\n[data-theme=\"dark\"] .react-select__menu,\n[data-theme=\"dark\"] [class$=\"__menu\"] {\n  background: rgba(17, 24, 39, 0.88) !important;\n  backdrop-filter: blur(16px) saturate(180%) !important;\n  -webkit-backdrop-filter: blur(16px) saturate(180%) !important;\n  border-color: rgba(255, 255, 255, 0.12) !important;\n  box-shadow: 0 20px 45px -8px rgba(0, 0, 0, 0.75), 0 0 0 1px rgba(255, 255, 255, 0.08) inset !important;\n}\n\n[data-theme=\"dark\"] .rm-glass-select-item,\n[data-theme=\"dark\"] .dropdown-menu .dropdown-item,\n[data-theme=\"dark\"] .select__option,\n[data-theme=\"dark\"] .react-select__option,\n[data-theme=\"dark\"] [class$=\"__option\"] {\n  color: #E2E8F0 !important;\n}\n\n[data-theme=\"dark\"] .rm-glass-select-item:hover:not(.disabled),\n[data-theme=\"dark\"] .dropdown-menu .dropdown-item:hover,\n[data-theme=\"dark\"] .select__option:hover,\n[data-theme=\"dark\"] .react-select__option:hover,\n[data-theme=\"dark\"] [class$=\"__option--is-focused\"] {\n  background: rgba(79, 70, 229, 0.22) !important;\n  color: #818CF8 !important;\n}\n\n[data-theme=\"dark\"] .rm-glass-select-item.selected,\n[data-theme=\"dark\"] .dropdown-menu .dropdown-item.active,\n[data-theme=\"dark\"] .select__option--is-selected {\n  background: rgba(79, 70, 229, 0.28) !important;\n  color: #A5B4FC !important;\n}\n\n/* =================================================================\n   GLOBAL TYPOGRAPHY & FONT ENHANCEMENTS\n   ================================================================= */\nbody, html, .page-wrapper, .card, input, button, select, textarea, .form-control, .table {\n  font-family: 'Plus Jakarta Sans', 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* =================================================================\n   FLOATING THEME CUSTOMIZER (Moved away from middle to Bottom-Right FAB)\n   ================================================================= */\n.sidebar-contact {\n  position: fixed !important;\n  bottom: 24px !important;\n  right: 24px !important;\n  top: auto !important;\n  left: auto !important;\n  transform: none !important;\n  z-index: 1045 !important;\n  width: auto !important;\n  height: auto !important;\n  background: transparent !important;\n  transition: all 0.3s ease !important;\n}\n\n.sidebar-contact .toggle-theme {\n  position: static !important;\n  background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%) !important;\n  color: #FFFFFF !important;\n  width: 48px !important;\n  height: 48px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border-radius: 50% !important;\n  box-shadow: 0 8px 24px rgba(79, 70, 229, 0.45) !important;\n  cursor: pointer !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  border: 2px solid rgba(255, 255, 255, 0.45) !important;\n  backdrop-filter: blur(8px) !important;\n}\n\n.sidebar-contact .toggle-theme:hover {\n  width: 48px !important;\n  transform: scale(1.1) rotate(45deg) !important;\n  background: linear-gradient(135deg, #4338CA 0%, #6D28D9 100%) !important;\n  box-shadow: 0 12px 32px rgba(79, 70, 229, 0.65) !important;\n}\n\n.sidebar-contact .toggle-theme i {\n  font-size: 20px !important;\n  color: #FFFFFF !important;\n}\n\n/* =================================================================\n   PAGE HEADERS, TITLES & BREADCRUMBS OVERHAUL\n   ================================================================= */\n.page-header {\n  margin-bottom: 24px !important;\n  padding-bottom: 12px !important;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.7) !important;\n  transition: var(--rm-transition);\n}\n\n[data-theme=\"dark\"] .page-header {\n  border-bottom-color: rgba(51, 65, 85, 0.6) !important;\n}\n\n.page-title {\n  font-size: 1.3rem !important;\n  font-weight: 800 !important;\n  letter-spacing: -0.025em !important;\n  color: var(--rm-text-primary) !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 10px !important;\n  margin-bottom: 0 !important;\n}\n\n.head-icons a,\n.head-icons button {\n  width: 36px !important;\n  height: 36px !important;\n  border-radius: 10px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  background: rgba(255, 255, 255, 0.8) !important;\n  border: 1px solid rgba(226, 232, 240, 0.9) !important;\n  color: var(--rm-text-secondary) !important;\n  backdrop-filter: blur(8px) !important;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04) !important;\n  transition: all 0.2s ease !important;\n  text-decoration: none !important;\n}\n\n.head-icons a:hover,\n.head-icons button:hover {\n  background: #ffffff !important;\n  border-color: var(--rm-primary) !important;\n  color: var(--rm-primary) !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.15) !important;\n}\n\n[data-theme=\"dark\"] .head-icons a,\n[data-theme=\"dark\"] .head-icons button {\n  background: rgba(30, 41, 59, 0.85) !important;\n  border-color: rgba(51, 65, 85, 0.85) !important;\n  color: #94A3B8 !important;\n}\n\n[data-theme=\"dark\"] .head-icons a:hover,\n[data-theme=\"dark\"] .head-icons button:hover {\n  background: rgba(51, 65, 85, 1) !important;\n  color: #FFFFFF !important;\n  border-color: var(--rm-primary) !important;\n}\n\n/* =================================================================\n   MODERN SEGMENTED TABS (Replacing Dated Red Underlines)\n   ================================================================= */\n.nav-tabs,\n.booking-tabs,\nul.nav.nav-tabs {\n  border-bottom: none !important;\n  background: rgba(241, 245, 249, 0.8) !important;\n  padding: 5px !important;\n  border-radius: 14px !important;\n  display: inline-flex !important;\n  gap: 5px !important;\n  border: 1px solid rgba(226, 232, 240, 0.9) !important;\n  margin-bottom: 22px !important;\n  backdrop-filter: blur(10px) !important;\n  flex-wrap: wrap !important;\n}\n\n.nav-tabs .nav-item {\n  margin-bottom: 0 !important;\n}\n\n.nav-tabs .nav-link,\n.booking-tabs a,\n.booking-tabs button {\n  border: none !important;\n  border-radius: 10px !important;\n  padding: 9px 20px !important;\n  font-weight: 600 !important;\n  font-size: 0.88rem !important;\n  color: #64748B !important;\n  background: transparent !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 7px !important;\n  text-decoration: none !important;\n  cursor: pointer !important;\n}\n\n.nav-tabs .nav-link:hover,\n.booking-tabs a:hover {\n  color: var(--rm-primary) !important;\n  background: rgba(255, 255, 255, 0.7) !important;\n  transform: translateY(-1px);\n}\n\n.nav-tabs .nav-link.active,\n.booking-tabs a.active,\n.booking-tabs .active {\n  background: #FFFFFF !important;\n  color: var(--rm-primary) !important;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08), 0 0 0 1px rgba(79, 70, 229, 0.1) !important;\n  border-bottom: none !important;\n}\n\n/* Dark Mode Segmented Tabs */\n[data-theme=\"dark\"] .nav-tabs,\n[data-theme=\"dark\"] .booking-tabs,\n[data-theme=\"dark\"] ul.nav.nav-tabs {\n  background: rgba(30, 41, 59, 0.75) !important;\n  border-color: rgba(51, 65, 85, 0.85) !important;\n}\n\n[data-theme=\"dark\"] .nav-tabs .nav-link,\n[data-theme=\"dark\"] .booking-tabs a {\n  color: #94A3B8 !important;\n}\n\n[data-theme=\"dark\"] .nav-tabs .nav-link:hover,\n[data-theme=\"dark\"] .booking-tabs a:hover {\n  color: #FFFFFF !important;\n  background: rgba(51, 65, 85, 0.7) !important;\n}\n\n[data-theme=\"dark\"] .nav-tabs .nav-link.active,\n[data-theme=\"dark\"] .booking-tabs a.active,\n[data-theme=\"dark\"] .booking-tabs .active {\n  background: var(--rm-primary-gradient) !important;\n  color: #FFFFFF !important;\n  box-shadow: 0 4px 16px rgba(79, 70, 229, 0.45) !important;\n  border-bottom: none !important;\n}\n\n/* =================================================================\n   UNIVERSAL SOFT STATUS BADGES (High-End & Accessible)\n   ================================================================= */\n.badge,\n.badge-status,\ntd .badge,\n.table .badge {\n  font-family: inherit !important;\n  padding: 5px 12px !important;\n  border-radius: 9999px !important;\n  font-size: 0.74rem !important;\n  font-weight: 700 !important;\n  letter-spacing: 0.04em !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 5px !important;\n  line-height: 1.35 !important;\n  text-transform: uppercase !important;\n  border: 1px solid transparent !important;\n  box-shadow: none !important;\n  transition: all 0.2s ease !important;\n}\n\n/* Success / Approved / Active / Completed */\n.badge-success,\n.badge-soft-success,\n.badge.bg-success,\n.badge.bg-outline-success {\n  background: rgba(16, 185, 129, 0.13) !important;\n  color: #059669 !important;\n  border-color: rgba(16, 185, 129, 0.3) !important;\n}\n\n/* Danger / Expired / Rejected / Cancelled */\n.badge-danger,\n.badge-soft-danger,\n.badge.bg-danger,\n.badge.bg-outline-danger {\n  background: rgba(244, 63, 94, 0.13) !important;\n  color: #E11D48 !important;\n  border-color: rgba(244, 63, 94, 0.3) !important;\n}\n\n/* Warning / Pending / Review */\n.badge-warning,\n.badge-soft-warning,\n.badge.bg-warning,\n.badge.bg-outline-warning {\n  background: rgba(245, 158, 11, 0.13) !important;\n  color: #D97706 !important;\n  border-color: rgba(245, 158, 11, 0.3) !important;\n}\n\n/* Info / Planned / Scheduled */\n.badge-info,\n.badge-soft-info,\n.badge.bg-info,\n.badge.bg-outline-info {\n  background: rgba(14, 165, 233, 0.13) !important;\n  color: #0284C7 !important;\n  border-color: rgba(14, 165, 233, 0.3) !important;\n}\n\n/* Primary / Recurring / Sudden / Special */\n.badge-primary,\n.badge-soft-primary,\n.badge.bg-primary,\n.badge.bg-outline-primary {\n  background: rgba(79, 70, 229, 0.13) !important;\n  color: #4F46E5 !important;\n  border-color: rgba(79, 70, 229, 0.3) !important;\n}\n\n/* Dark Mode Badges (Luminescent soft glows) */\n[data-theme=\"dark\"] .badge-success,\n[data-theme=\"dark\"] .badge-soft-success,\n[data-theme=\"dark\"] .badge.bg-success {\n  background: rgba(16, 185, 129, 0.2) !important;\n  color: #34D399 !important;\n  border-color: rgba(16, 185, 129, 0.4) !important;\n}\n\n[data-theme=\"dark\"] .badge-danger,\n[data-theme=\"dark\"] .badge-soft-danger,\n[data-theme=\"dark\"] .badge.bg-danger {\n  background: rgba(244, 63, 94, 0.2) !important;\n  color: #FB7185 !important;\n  border-color: rgba(244, 63, 94, 0.4) !important;\n}\n\n[data-theme=\"dark\"] .badge-warning,\n[data-theme=\"dark\"] .badge-soft-warning,\n[data-theme=\"dark\"] .badge.bg-warning {\n  background: rgba(245, 158, 11, 0.2) !important;\n  color: #FBBF24 !important;\n  border-color: rgba(245, 158, 11, 0.4) !important;\n}\n\n[data-theme=\"dark\"] .badge-info,\n[data-theme=\"dark\"] .badge-soft-info,\n[data-theme=\"dark\"] .badge.bg-info {\n  background: rgba(14, 165, 233, 0.2) !important;\n  color: #38BDF8 !important;\n  border-color: rgba(14, 165, 233, 0.4) !important;\n}\n\n[data-theme=\"dark\"] .badge-primary,\n[data-theme=\"dark\"] .badge-soft-primary,\n[data-theme=\"dark\"] .badge.bg-primary {\n  background: rgba(79, 70, 229, 0.25) !important;\n  color: #A5B4FC !important;\n  border-color: rgba(79, 70, 229, 0.45) !important;\n}\n\n/* =================================================================\n   ACTION BUTTONS & CHIPS IN DATA TABLES\n   ================================================================= */\n.action-table-data,\n.table-action-btns {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n}\n\n.action-table-data a,\n.table-action-btn,\ntd .btn-icon,\ntd .btn-action,\ntd a.btn-primary,\ntd a.btn-info {\n  width: 34px !important;\n  height: 34px !important;\n  border-radius: 9px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  background: rgba(79, 70, 229, 0.08) !important;\n  color: var(--rm-primary) !important;\n  border: 1px solid rgba(79, 70, 229, 0.2) !important;\n  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  cursor: pointer !important;\n  text-decoration: none !important;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04) !important;\n  padding: 0 !important;\n}\n\n.action-table-data a:hover,\n.table-action-btn:hover,\ntd a.btn-primary:hover,\ntd a.btn-info:hover {\n  background: var(--rm-primary-gradient) !important;\n  color: #FFFFFF !important;\n  border-color: transparent !important;\n  transform: translateY(-2px) scale(1.08) !important;\n  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.38) !important;\n}\n\n[data-theme=\"dark\"] .action-table-data a,\n[data-theme=\"dark\"] .table-action-btn,\n[data-theme=\"dark\"] td a.btn-primary,\n[data-theme=\"dark\"] td a.btn-info {\n  background: rgba(30, 41, 59, 0.95) !important;\n  color: #818CF8 !important;\n  border-color: rgba(55, 65, 81, 0.85) !important;\n}\n\n[data-theme=\"dark\"] .action-table-data a:hover,\n[data-theme=\"dark\"] .table-action-btn:hover,\n[data-theme=\"dark\"] td a.btn-primary:hover,\n[data-theme=\"dark\"] td a.btn-info:hover {\n  background: var(--rm-primary-gradient) !important;\n  color: #FFFFFF !important;\n  border-color: transparent !important;\n  box-shadow: 0 6px 18px rgba(79, 70, 229, 0.5) !important;\n}\n\n/* =================================================================\n   SLEEK MODERN PAGINATION\n   ================================================================= */\n.pagination,\n.ant-pagination,\n.custom-pagination {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: flex-end !important;\n  gap: 6px !important;\n  margin-top: 20px !important;\n  padding: 8px 0 !important;\n  list-style: none !important;\n}\n\n.page-item .page-link,\n.ant-pagination-item,\n.ant-pagination-prev button,\n.ant-pagination-next button,\n.ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination-next .ant-pagination-item-link,\n.custom-pagination button {\n  min-width: 36px !important;\n  height: 36px !important;\n  padding: 0 14px !important;\n  border-radius: 9px !important;\n  border: 1px solid rgba(226, 232, 240, 0.9) !important;\n  background: #FFFFFF !important;\n  color: #475569 !important;\n  font-size: 0.85rem !important;\n  font-weight: 600 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  transition: all 0.2s ease !important;\n  text-decoration: none !important;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;\n}\n\n.page-item .page-link:hover,\n.ant-pagination-item:hover,\n.ant-pagination-item-link:hover,\n.custom-pagination button:hover:not(:disabled) {\n  border-color: var(--rm-primary) !important;\n  color: var(--rm-primary) !important;\n  background: rgba(79, 70, 229, 0.06) !important;\n  transform: translateY(-1px) !important;\n}\n\n.page-item.active .page-link,\n.ant-pagination-item-active,\n.ant-pagination-item-active a {\n  background: var(--rm-primary-gradient) !important;\n  border-color: transparent !important;\n  color: #FFFFFF !important;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.35) !important;\n}\n\n[data-theme=\"dark\"] .page-item .page-link,\n[data-theme=\"dark\"] .ant-pagination-item,\n[data-theme=\"dark\"] .ant-pagination-prev button,\n[data-theme=\"dark\"] .ant-pagination-next button,\n[data-theme=\"dark\"] .ant-pagination-prev .ant-pagination-item-link,\n[data-theme=\"dark\"] .ant-pagination-next .ant-pagination-item-link,\n[data-theme=\"dark\"] .custom-pagination button {\n  background: rgba(30, 41, 59, 0.85) !important;\n  border-color: rgba(51, 65, 85, 0.85) !important;\n  color: #94A3B8 !important;\n}\n\n[data-theme=\"dark\"] .page-item .page-link:hover,\n[data-theme=\"dark\"] .ant-pagination-item:hover,\n[data-theme=\"dark\"] .custom-pagination button:hover:not(:disabled) {\n  color: #FFFFFF !important;\n  background: rgba(51, 65, 85, 0.95) !important;\n  border-color: var(--rm-primary) !important;\n}\n\n[data-theme=\"dark\"] .page-item.active .page-link,\n[data-theme=\"dark\"] .ant-pagination-item-active {\n  background: var(--rm-primary-gradient) !important;\n  border-color: transparent !important;\n  color: #FFFFFF !important;\n  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.5) !important;\n}\n\n/* =================================================================\n   MODERN SWEETALERT2 STYLING (Glassmorphic Popups)\n   ================================================================= */\n.swal2-popup {\n  border-radius: 20px !important;\n  padding: 24px 28px !important;\n  border: 1px solid rgba(226, 232, 240, 0.9) !important;\n  box-shadow: 0 25px 65px -12px rgba(15, 23, 42, 0.25) !important;\n  background: rgba(255, 255, 255, 0.98) !important;\n  backdrop-filter: blur(20px) !important;\n  -webkit-backdrop-filter: blur(20px) !important;\n  font-family: inherit !important;\n}\n\n.swal2-title {\n  font-size: 1.35rem !important;\n  font-weight: 700 !important;\n  color: #0F172A !important;\n  margin-bottom: 8px !important;\n}\n\n.swal2-html-container {\n  font-size: 0.92rem !important;\n  color: #475569 !important;\n  line-height: 1.55 !important;\n}\n\n.swal2-actions {\n  gap: 12px !important;\n  margin-top: 24px !important;\n}\n\n.swal2-confirm {\n  background: var(--rm-primary-gradient) !important;\n  border-radius: 10px !important;\n  font-weight: 600 !important;\n  padding: 10px 24px !important;\n  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.35) !important;\n  border: none !important;\n  transition: all 0.2s ease !important;\n}\n\n.swal2-confirm:hover {\n  transform: translateY(-2px) !important;\n  box-shadow: 0 6px 18px rgba(79, 70, 229, 0.45) !important;\n}\n\n.swal2-cancel {\n  background: #F1F5F9 !important;\n  color: #475569 !important;\n  border-radius: 10px !important;\n  font-weight: 600 !important;\n  padding: 10px 24px !important;\n  border: 1px solid #E2E8F0 !important;\n  transition: all 0.2s ease !important;\n}\n\n.swal2-cancel:hover {\n  background: #E2E8F0 !important;\n  color: #0F172A !important;\n}\n\n[data-theme=\"dark\"] .swal2-popup {\n  background: rgba(17, 24, 39, 0.96) !important;\n  border-color: rgba(55, 65, 81, 0.85) !important;\n  box-shadow: 0 25px 65px -12px rgba(0, 0, 0, 0.8) !important;\n  color: #F8FAFC !important;\n}\n\n[data-theme=\"dark\"] .swal2-title {\n  color: #F8FAFC !important;\n}\n\n[data-theme=\"dark\"] .swal2-html-container {\n  color: #94A3B8 !important;\n}\n\n[data-theme=\"dark\"] .swal2-cancel {\n  background: rgba(30, 41, 59, 0.9) !important;\n  color: #CBD5E1 !important;\n  border-color: rgba(55, 65, 81, 0.8) !important;\n}\n\n/* =================================================================\n   GOOGLE MAPS DARK MODE STYLING\n   ================================================================= */\n[data-theme=\"dark\"] .google-map-container,\n[data-theme=\"dark\"] .gm-style > div:first-child > div:first-child {\n  filter: invert(90%) hue-rotate(180deg) contrast(90%) brightness(95%);\n}\n\n[data-theme=\"dark\"] .gm-style-iw {\n  background: #111827 !important;\n  color: #F8FAFC !important;\n  border-radius: 12px !important;\n}\n\n/* =================================================================\n   HEADER LOGO & COLLAPSE BUTTON FIXES FOR DARK MODE\n   ================================================================= */\n[data-theme=\"dark\"] .header-left #toggle_btn {\n  background: rgba(30, 41, 59, 0.9) !important;\n  color: #94A3B8 !important;\n  border: 1px solid rgba(51, 65, 85, 0.8) !important;\n}\n\n[data-theme=\"dark\"] .header-left #toggle_btn:hover {\n  background: var(--rm-primary) !important;\n  color: #FFFFFF !important;\n  border-color: transparent !important;\n}\n\n/* Ensure clean logo contrast */\n.logo img, .logo-small img {\n  transition: filter 0.3s ease;\n}\n\n[data-theme=\"dark\"] .logo-small img {\n  filter: brightness(1.2);\n}\n\n/* =================================================================\n   STAT CARDS & KPI WIDGET OVERHAULS (For Booking Dashboard, etc.)\n   ================================================================= */\n.stat-card {\n  background: var(--rm-glass-bg) !important;\n  backdrop-filter: var(--rm-glass-blur) !important;\n  -webkit-backdrop-filter: var(--rm-glass-blur) !important;\n  border: 1px solid var(--rm-glass-border) !important;\n  border-radius: var(--rm-radius-lg) !important;\n  box-shadow: var(--rm-glass-shadow) !important;\n  color: var(--rm-text-primary) !important;\n  transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  cursor: pointer !important;\n  position: relative !important;\n  overflow: hidden !important;\n}\n\n.stat-card:hover {\n  transform: translateY(-5px) !important;\n  box-shadow: var(--rm-glass-shadow-hover) !important;\n  border-color: rgba(79, 70, 229, 0.3) !important;\n}\n\n[data-theme=\"dark\"] .stat-card {\n  background: rgba(17, 24, 39, 0.9) !important;\n  border-color: rgba(55, 65, 81, 0.8) !important;\n  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.6) !important;\n  color: #F8FAFC !important;\n}\n\n[data-theme=\"dark\"] .stat-card h3,\n[data-theme=\"dark\"] .stat-card h4,\n[data-theme=\"dark\"] .stat-card h5,\n[data-theme=\"dark\"] .stat-card p,\n[data-theme=\"dark\"] .stat-card span,\n[data-theme=\"dark\"] .stat-card .text-2xl,\n[data-theme=\"dark\"] .stat-card .font-bold {\n  color: #F8FAFC !important;\n}\n\n[data-theme=\"dark\"] .stat-card .text-gray-500,\n[data-theme=\"dark\"] .stat-card .text-muted {\n  color: #94A3B8 !important;\n}\n\n/* =================================================================\n   CHART & APEXCHARTS OVERHAUL FOR DARK MODE\n   ================================================================= */\n[data-theme=\"dark\"] .apexcharts-canvas text {\n  fill: #94A3B8 !important;\n}\n\n[data-theme=\"dark\"] .apexcharts-tooltip {\n  background: rgba(17, 24, 39, 0.96) !important;\n  border: 1px solid rgba(55, 65, 81, 0.85) !important;\n  color: #F8FAFC !important;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5) !important;\n}\n\n[data-theme=\"dark\"] .apexcharts-tooltip-title {\n  background: rgba(30, 41, 59, 0.95) !important;\n  border-bottom: 1px solid rgba(55, 65, 81, 0.85) !important;\n  color: #F8FAFC !important;\n}\n\n[data-theme=\"dark\"] .apexcharts-gridline {\n  stroke: rgba(55, 65, 81, 0.5) !important;\n}\n\n/* =================================================================\n   MODAL & OFFCANVAS OVERHAUL FOR DARK MODE\n   ================================================================= */\n[data-theme=\"dark\"] .modal-backdrop {\n  opacity: 0.75 !important;\n}\n\n[data-theme=\"dark\"] .btn-close {\n  filter: invert(1) grayscale(100%) brightness(200%) !important;\n}\n\n[data-theme=\"dark\"] .offcanvas {\n  background: rgba(17, 24, 39, 0.96) !important;\n  color: #F8FAFC !important;\n  border-color: rgba(55, 65, 81, 0.85) !important;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
